import React, {useState, useEffect} from 'react'
import useImage from 'use-image';

// Bootstrap components
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Collapse from 'react-bootstrap/Collapse';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import { Carousel, Accordion, Alert } from 'react-bootstrap';

// Pagination for performance
import PaginatedItems from '../shared/AccordionPaginatedItems';

// Rich text editing through html2canvas
// https://konvajs.org/docs/sandbox/Rich_Text.html
// https://blog.logrocket.com/export-react-components-as-images-html2canvas/
import html2canvas from "html2canvas";

// React-color for color picker 
import reactCSS from 'reactcss'
import { SketchPicker, CompactPicker } from 'react-color'

// React Konva components
import { Shape, Text, Stage, Layer, Transformer, Rect, Circle } from 'react-konva';
import { Image as ImageKonva } from 'react-konva';

// Text component
import { EditableTextInput } from "./EditableTextInput";

// For confirmation dialogs
import {confirm} from 'react-bootstrap-confirmation';

// Custom Icons Bootstrap
import { ChevronRight, ChevronLeft, SquareFill, Palette, TextLeft, TextCenter, TextRight, PlusSquare, DashSquare, Wallet2, Wrench, Fonts, TextareaT, Upload, Book, Front, SymmetryVertical, Trash, Download, XLg, Dice5, PlusCircle, ArrowsCollapse } from 'react-bootstrap-icons';

// Toast
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// For shared context modules ------
import { useSharedNavigationFunctions } from "../../shared/NavigationFunctions";
import { useSharedNavigationPageGlobalState } from "../../shared/NavigationPageGlobalState";
import { useSharedUIFunctions } from "../../shared/UIFunctions";


// --------------
// MAIN COMPONENT
// --------------

        
const CardGenerator = (props) => {

    // Refs for the Canvas
    const uiCardBackgroundHeader = React.useRef(null);
    const uiCardPFPBorder = React.useRef(null);
    const uiCardCentralIcon = React.useRef(null);
    const uiCardTextOne = React.useRef(null);
    const uiCardTextTwo = React.useRef(null);
    const uiCardTextThree = React.useRef(null);
    const uiCardIcon = React.useRef(null);
    const uiCardBackgroundBorder = React.useRef(null);
    const uiCardPfp = React.useRef(null);
    const uiCardScroll = React.useRef(null);

    // Static images for the card 
    const [cardBackgroundTest] = useImage("images/partners/whiskers/backgrounds/sunlight.PNG", "Anonymous");
    const [cardScrollElement] = useImage("images/partners/whiskers/card-generator/card_scroll.png", "Anonymous");
    const [cardIconImage] = useImage("images/partners/whiskers/card-generator/card_icon.png", "Anonymous");
    
    // Dynamic images for the card 
    const defaultPfpImage = "images/partners/whiskers/card-generator/card_pfp.png";
    const [cardPfpImage, setCardPfpImage] = useState(null);
    useEffect(() => {
        //console.log("In useeffect...");
        updateCardPfpImage(defaultPfpImage);
    }, []);

    // Dynamic text for the card
    const [cardTextName, setCardTextName] = useState("or Provide a Custom Name");
    const [cardTextTitle, setCardTextTitle] = useState("Card title");
    const [cardTextDetails, setCardTextDetails] = useState("Card flavor text");

     // Handling controls for the uploaded images to be changes by the user -----------------------
     
     const [userUploadPFPPosX, setUserUploadPFPPosX] = useState("10");              // Default posX for image location 
     const [userUploadPFPPosY, setUserUploadPFPPosY] = useState("10");              // Default posY for image location
     const [userUploadPFPWidth, setUserUploadPFPWidth] = useState("280");           // Default width for image location
     const [userUploadPFPHeight, setUserUploadPFPHeight] = useState("328");         // Default height for image location
    
     // Method that intercept input value change
     // This is use for letting the user specify the name of the card
     const updateInputValueForUploadedPFPImageProperties = (val, property) => {
        //console.log("updateInputValueForUploadedPFPImageProperties: We are updating input value to:" + val + " for property:" + Property);
        switch(property) {
            case 'userUploadPFPPosX':
                setUserUploadPFPPosX(val);
                return;
            case 'userUploadPFPPosY':
                setUserUploadPFPPosY(val);
                return;
            case 'userUploadPFPWidth':
                setUserUploadPFPWidth(val);
                return;
            case 'userUploadPFPHeight':
                setUserUploadPFPHeight(val);
                return;
            default:
              console.error("updateInputValueForUploadedPFPImageProperties: INVALID property value: " + property)
        }
     }
        
     // Handling controls for the uploaded images to be changes by the user ----------------------]
     

    // Handling the type of asset displayed on canvas (NFT collection of User uploaded) -----------
    
    const [isPFPOnCanvasUploaded, setIsPFPOnCanvasUploaded] = useState(false);      // If the user upload a card manually?
    const [isPFPLegendSelected, setIsPFPLegendSelected] = useState(false);          // If the user selected e legendary 1:1 (ie. a 1:1)
    

    // Handling the type of asset displayed on canvas (NFT collection of User uploaded) ----------]
    
    // Handling Card Effect text ------------------------------------------------------------------

    const [cardTextCardEffect, setCardTextCardEffect] = useState("Card ability text");

    const [pfpEquipmentTraitToCardEffectText, setPfpEquipmentTraitToCardEffectText] = useState(
        [
            { value: "None", effectText: "XXXXXXX" },
            { value: "Angler Fish (Black)", effectText: "XXXXXX" },
            { value: "Angler Fish (Blue)", effectText: "XXXXXXX" },
            { value: "Assassin", effectText: "XXXXXX" },
            { value: "Barbarian", effectText: "XXXXXXX" },
            { value: "Berkserker", effectText: "XXXXXX" },
            { value: "Black Partyhat", effectText: "XXXXXXX" },
            { value: "Blue Cat Robe", effectText: "XXXXXX" },
            { value: "Blue Partyhat", effectText: "XXXXXXX" },
            { value: "Chieftain & Blobfish", effectText: "XXXXXX" },
            { value: "Chronicler", effectText: "XXXXXXX" },
            { value: "Clouded Flame Robe", effectText: "XXXXXX" },
            { value: "Dinomander", effectText: "XXXXXXX" },
            { value: "Dinomandera", effectText: "XXXXXX" },
            { value: "Druid of the Sands", effectText: "XXXXXXX" },
            { value: "Druid of the Woods", effectText: "XXXXXX" },
            { value: "Emperor's Regalia", effectText: "XXXXXXX" },
            { value: "Executioner", effectText: "XXXXXX" },
            { value: "Feathershark Cloak", effectText: "XXXXXXX" },
            { value: "Forest Denizen", effectText: "XXXXXX" },
            { value: "Frost Fair Bladesman", effectText: "XXXXXXX" },
            { value: "Green Dragon Crescent Bladesman", effectText: "XXXXXX" },
            { value: "Green Partyhat", effectText: "XXXXXXX" },
            { value: "Guardsman", effectText: "XXXXXXX" },
            { value: "Harbinger", effectText: "XXXXXXX" },
            { value: "Herald of Shadows", effectText: "XXXXXXX" },
            { value: "Heraldric Axeman", effectText: "XXXXXXX" },
            { value: "Horned Knight", effectText: "XXXXXXX" },
            { value: "Icewind Scout", effectText: "XXXXXXX" },
            { value: "Lancer", effectText: "XXXXXXX" },
            { value: "Marauder & Black Cat", effectText: "XXXXXXX" },
            { value: "Mercenary", effectText: "XXXXXXX" },
            { value: "Mountain Dweller", effectText: "XXXXXXX" },
            { value: "Nimbus", effectText: "XXXXXXX" },
            { value: "Nobleman", effectText: "XXXXXXX" },
            { value: "Nomad", effectText: "XXXXXXX" },
            { value: "Paladin", effectText: "XXXXXXX" },
            { value: "Purple Partyhat", effectText: "XXXXXXX" },
            { value: "Rainbow Partyhat", effectText: "XXXXXXX" },
            { value: "Red Partyhat", effectText: "XXXXXXX" },
            { value: "Robe of Breathing Lands", effectText: "XXXXXXX" },
            { value: "Robe of Chasing Winds", effectText: "XXXXXXX" },
            { value: "Robe of Dancing Flames", effectText: "XXXXXXX" },
            { value: "Robe of Falling Water", effectText: "XXXXXXX" },
            { value: "Robe of Singing Storms", effectText: "XXXXXXX" },
            { value: "Rosewind Inquisitor", effectText: "XXXXXXX" },
            { value: "Royal Messenger", effectText: "XXXXXXX" },
            { value: "Salamander Robe", effectText: "XXXXXXX" },
            { value: "Sandshark Cloak", effectText: "XXXXXXX" },
            { value: "Scalemander Robe", effectText: "XXXXXXX" },
            { value: "Shadow Paladin", effectText: "XXXXXXX" },
            { value: "Shadow Robe", effectText: "XXXXXXX" },
            { value: "Strategist", effectText: "XXXXXXX" },
            { value: "Swamp Frog", effectText: "XXXXXXX" },
            { value: "Under the Sea", effectText: "XXXXXXX" },
            { value: "Vagabond's Cowl", effectText: "XXXXXXX" },
            { value: "Vagrant's Rags", effectText: "XXXXXXX" },
            { value: "Wanderer", effectText: "XXXXXXX" },
            { value: "Western Citizen", effectText: "XXXXXXX" },
            { value: "Whiskeress & Cat", effectText: "XXXXXXX" },
            { value: "Whiskeress Sprout", effectText: "XXXXXXX" },
            { value: "Whiskerman", effectText: "XXXXXXX" },
            { value: "Whisky Smalls", effectText: "XXXXXXX" },
            { value: "White Partyhat", effectText: "XXXXXXX" },
            { value: "Wildwood Ranger", effectText: "XXXXXXX" },
            { value: "Windchaser", effectText: "XXXXXXX" },
            { value: "Windrose Scholar", effectText: "XXXXXXX" },
            { value: "Winged Knight", effectText: "XXXXXXX" },
            { value: "Yellow Partyhat", effectText: "XXXXXXX" },
        ]
    );
    
    /**
     * retrieve the card effect text based on the equipment trait value of the PFP
     * 
     * @param {*} equipmentTraitValue the value to lookup the card effect for
     */
    const fetchCardEffectFromEquipmentTraitValue = (equipmentTraitValue) => {
        const mapping = pfpEquipmentTraitToCardEffectText;
        //search the item from the list
        for (var i=0; i<mapping.length; i++) {
            if (mapping[i].value.toLowerCase() === equipmentTraitValue) {
                console.log("fetchCardEffectFromEquipmentTraitValue: Found mapping of equipment value=" + equipmentTraitValue + " to effect=" , mapping[i].effectText);
                return mapping[i].effectText;
            }
        }
        console.error("fetchCardEffectFromEquipmentTraitValue: We could not find a mapping of effect for equipment value=" + equipmentTraitValue);
        return null;
    };

    /**
     * retrieve the card effect text based on the card text selected 
     * 
     * @param {*} cardText the value to lookup the card effect for
     */
    const fetchCardEffectFromCardTextValue = (cardText) => {
        const mapping = cardTextToCardEffectText;
        //search the item from the list
        for (var i=0; i<mapping.length; i++) {

            if (mapping[i].text.toLowerCase() === cardText.toLowerCase()) {
                //console.log("fetchCardEffectFromCardTextValue: Found mapping of card text=" + cardText + " with effect=" , mapping[i].value);
                return mapping[i].value;
            }
        }
        console.error("fetchCardEffectFromCardTextValue: We could not find a mapping of effect for card text=" + cardText);
        return null;
    };

    

    // Handling Card Effect text -----------------------------------------------------------------]
    
    // Handling Card Border Color picker ----------------------------------------------------------

    // Color pickers
    const [displayBorderStartColorPicker, setDisplayBorderStartColorPicker] = useState(false);
    const [displayBorderEndColorPicker, setDisplayBorderEndColorPicker] = useState(false);
    const [cardBorderStartColor, setCardBorderStartColor] = useState(
        {   r: '104',
            g: '204',
            b: '202',
            a: '1',
        }
    );
    const [cardBorderEndColor, setCardBorderEndColor] = useState(
        {   r: '241',
            g: '112',
            b: '19',
            a: '1',
        }
    );
    const [cardBorderStartColorFromPicker, setCardBorderStartColorFromPicker] = useState(
        {   r: '104',
            g: '204',
            b: '202',
            a: '1',
        }
    );
    const [cardBorderEndColorFromPicker, setCardBorderEndColorFromPicker] = useState(
        {   r: '241',
            g: '112',
            b: '19',
            a: '1',
        }
    );

    // Click on the color picker 
    const handleBorderColorPickerClick = (colorPickerId) => {
        //console.log("INIT: handleClick with ID:" + colorPickerId);
        if (colorPickerId == "startColor") {
            //console.log("     handleBorderColorPickerClick START COLOR");
            setDisplayBorderStartColorPicker( !displayBorderStartColorPicker );
        } 
        if (colorPickerId == "endColor") {
            //console.log("     handleBorderColorPickerClick END COLOR");
            setDisplayBorderEndColorPicker( !displayBorderEndColorPicker );
        }
        
    };
    // Closing the color picker 
    const handleBorderColorPickerClose = (colorPickerId) => {
        //console.log("INIT: handleClose with ID:" + colorPickerId);
        if (colorPickerId == "startColor") {
            //console.log("     handleBorderColorPickerClose START COLOR");
            setDisplayBorderStartColorPicker( false );
        } 
        if (colorPickerId == "endColor") {
            //console.log("     handleBorderColorPickerClose END COLOR");
            setDisplayBorderEndColorPicker( false );
        }
    };
    // Making a change to the color picker
    const handleBorderColorPickerChange = (color, colorPickerId) => {
        //console.log("INIT: handleBorderColorPickerChange with ID:" + colorPickerId + " and COLOR: " + color);
        if (colorPickerId == "startColor") {
            //console.log("     handleBorderColorPickerChange START COLOR");
            setCardBorderStartColor( color.rgb );
        } 
        if (colorPickerId == "endColor") {
            //console.log("     handleBorderColorPickerChange END COLOR");
            setCardBorderEndColor( color.rgb );
        }
    };

    /**
     * Convert a set of RGB value into their hex value 
     * @param {*} r red value 
     * @param {*} g green value
     * @param {*} b blue value 
     * @returns Return the hex value for the corresponding RGB values 
     */
    function rgbToHex(r, g, b) {
        //console.log("rgbToHex r=" + r + " g=" + g + " b=" + b);
        return "#" + (1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1);
    }

    /*
     * Convert an hex value #ab231f into a rgba component 
     * @param {*} hex the string value to convert 
     * @returns an object with r, g, b, a property 
     */
    const hexToRgb = (hex) => {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: '' + parseInt(result[1], 16),
          g: '' + parseInt(result[2], 16),
          b: '' + parseInt(result[3], 16),
          a: '1'
        } : null;
    }

    // Making a change to the native input color picker
    const handleBorderColorPickerChangeFromRGB = (colorRGB, colorPickerId) => {
        //console.log("INIT: handleBorderColorPickerChangeFromRGB with ID:" + colorPickerId + " and COLOR: " + colorRGB);
        if (colorPickerId == "startColor") {
            //console.log("     handleBorderColorPickerChangeFromRGB START COLOR");
            const color = hexToRgb(colorRGB);
            console.log("     handleBorderColorPickerChangeFromRGB color=", color);
            setCardBorderStartColor( color );
        } 
        if (colorPickerId == "endColor") {
            //console.log("     handleBorderColorPickerChangeFromRGB START COLOR");
            const color = hexToRgb(colorRGB);
            console.log("     handleBorderColorPickerChangeFromRGB color=", color);
            setCardBorderEndColor( color );
        } 
    };



    

    // Handling Card Border Color picker ---------------------------------------------------------]

    // Handling PFP Color background --------------------------------------------------------------

    // PFP Color background
    const [pfpBackgroundColor, setPfpBackgroundColor] = useState(
        {   r: '164',
            g: '132',
            b: '203',
            a: '0',
        }
    );
    // Mapping PFP Origin trait to background Color 
    const [pfpOriginTraitToBackgroundColor, setPfpOriginTraitToBackgroundColor] = useState(
        [
            { value: "Sunlight",    // Beige
              color: {
                r: '214',
                g: '189',
                b: '171',
                a: '0'
              }
            },  
            { value: "Twilight",    // Pink
              color: {
                r: '225',
                g: '164',
                b: '179',
                a: '0'
              }
            },
            { value: "Midnight",    // Purple (default card)
              color: {
                r: '164',
                g: '132',
                b: '203',
                a: '0'
              }
            },
            { value: "Abyss",       // Black
              color: {
                r: '83',
                g: '87',
                b: '99',
                a: '0'
              }
            },
            { value: "Trenches",    // Red
              color: {
                r: '208',
                g: '76',
                b: '80',
                a: '0'
              }
            },
            { value: "Legend_412", 
              color: {
                r: '140',
                g: '42',
                b: '24',
                a: '0'
              }
            },
            { value: "Legend_878", 
              color: {
                r: '62',
                g: '97',
                b: '53',
                a: '0'
              }
            },
            { value: "Legend_1246", 
              color: {
                r: '252',
                g: '183',
                b: '244',
                a: '0'
              }
            },
            { value: "Legend_1840", 
              color: {
                r: '78',
                g: '156',
                b: '132',
                a: '1'
              }
            },
            { value: "Legend_2015", 
              color: {
                r: '176',
                g: '227',
                b: '242',
                a: '0'
              }
            },
            { value: "Legend_2355", 
              color: {
                r: '236',
                g: '173',
                b: '102',
                a: '0'
              }
            },
            { value: "Legend_2821", 
              color: {
                r: '90',
                g: '61',
                b: '112',
                a: '0'
              }
            },
            { value: "Legend_3244", 
              color: {
                r: '100',
                g: '150',
                b: '95',
                a: '0'
              }
            },
            { value: "Legend_3837", 
              color: {
                r: '244',
                g: '216',
                b: '241',
                a: '0'
              }
            },
            { value: "Legend_4303", 
              color: {
                r: '255',
                g: '255',
                b: '255',
                a: '0'
              }
            },
            { value: "Legend_4943", 
              color: {
                r: '14',
                g: '30',
                b: '41',
                a: '0'
              }
            },
            { value: "Legend_5369", 
              color: {
                r: '226',
                g: '51',
                b: '73',
                a: '0'
              }
            }

        ]
    );

    /**
     * retrieve a color object match the background color of a PFP based on its origin Trait value
     * 
     * @param {*} originTraitValue the value to lookup the color for
     */
    const fetchPfpBackgroundColorFromTraitValue = (originTraitValue) => {
        const mapping = pfpOriginTraitToBackgroundColor;
        //search the item from the list
        for (var i=0; i<mapping.length; i++) {
            if (mapping[i].value.toLowerCase() === originTraitValue) {
                //console.log("fetchPfpBackgroundColorFromTraitValue: Found mapping color to origin trait=" + originTraitValue + " with color=" , mapping[i].color);
                return mapping[i].color;
            }
        }
        console.error("fetchPfpBackgroundColorFromTraitValue: We could not find a mapping color for originTrait=" + originTraitValue);
        return null;
    };

    // Handling PFP Color background -------------------------------------------------------------]

    // Handling Card Names & Card Text -----------------------------------------------------------]

    /**
     * Function that render rich text for card text 
     */
    const renderTextCardName = () => {
        //console.log("In render text...");
        // convert DOM into image
        html2canvas(document.querySelector('.card-name-rendered-container'), {
            backgroundColor: 'rgba(0,0,0,0)',
        }).then((canvas) => {
            // show it inside Konva.Image
            // console.log("canvas=", canvas);
            setCardRenderedTextCardName(canvas);
        });
    };

    /**
     * Function that render rich text for card text 
     */
    const renderTextCardText = () => {
        html2canvas(document.querySelector('.card-text-rendered-container'), {
            backgroundColor: 'rgba(0,0,0,0)',
        }).then((canvas) => {
            // show it inside Konva.Image
            // console.log("canvas=", canvas);
            setCardRenderedTextCardText(canvas);
        });

    };

    // const renderCardNameText = (text) => {
    //     if (text === null) { return }
    //     const parts = text.split(/\*\*/); // split the text by '**'
    //     return parts.map((part, index) => {
    //       if (index % 2 === 1) { // check if the part is between '**'
    //         return <span key={index} className="card-name-rendered-text-bold">{part}</span>; // render bold text
    //       }
    //       return <span key={index} className="card-name-rendered-text-normal">{part}</span>; // render regular text
    //     });
    // };
      
    //     return replacedText;
    // };
 
    const renderCardNameText = (text) => {
        // Regex pattern for bold formatting: **text**
        const boldRegex = /\*\*(.*?)\*\*/g;
        // Regex pattern for italic formatting: __text__
        const italicRegex = /__(.*?)__/g;
        // Replace **text** with <span class="bold">text</span>
        const boldText = text.replace(boldRegex, '<span class="card-name-rendered-text-bold">$1</span>');
        // Replace __text__ with <span class="italic">text</span>
        const italicText = boldText.replace(italicRegex, '<span class="card-name-rendered-text-italic">$1</span>');
        // Render the HTML markup
        return <div dangerouslySetInnerHTML={{ __html: italicText }} />;
    }  
      
    // const renderCardTextText = (text) => {
    //     if (text === null) { return }
    //     const parts = text.split(/\*\*/); // split the text by '**'
    //     return parts.map((part, index) => {
    //       if (index % 2 === 1) { // check if the part is between '**'
    //         return <span key={index} className="card-text-rendered-text-bold">{part}</span>; // render bold text
    //       }
    //       return <span key={index} className="card-text-rendered-text-normal">{part}</span>; // render regular text
    //     });
    // };

    const renderCardTextText = (text) => {
        // Regex pattern for bold formatting: **text**
        const boldRegex = /\*\*(.*?)\*\*/g;
        // Regex pattern for italic formatting: __text__
        const italicRegex = /__(.*?)__/g;
        // Replace **text** with <span class="bold">text</span>
        const boldText = text.replace(boldRegex, '<span class="card-text-rendered-text-bold">$1</span>');
        // Replace __text__ with <span class="italic">text</span>
        const italicText = boldText.replace(italicRegex, '<span class="card-text-rendered-text-italic">$1</span>');
        // Render the HTML markup
        return <div dangerouslySetInnerHTML={{ __html: italicText }} />;
    } 

    // batch updates, so we don't render text too frequently
    var timeout = null;
    function requestRichTextItemToBeUpdates() {
        if (timeout) {
            return;
        }
        timeout = setTimeout(function () {
        timeout = null;
            renderTextCardName();
            renderTextCardText();
        }, 100);
    }

    const [cardRenderedTextCardName, setCardRenderedTextCardName] = useState(null);
    const [cardNameRawText, setCardNameRawText] = useState("**SIGNATURE:** Absolute Serenity");
    const [cardNameRichText, setCardNameRichText] = useState(
        "<strong>SIGNATURE:</strong> Absolute Serenity"
    );

    const [cardRenderedTextCardText, setCardRenderedTextCardText] = useState(null);
    const [cardTextRawText, setCardTextRawText] = useState("Card **ability** description");
    const [cardTextRichTextHtml, setCardTextRichTextHtml] = useState("Card ability description");
    //const [cardTextRichText, setCardTextRichText] = useState("Card effect description");

    useEffect(() => {
        //console.log("In use effect to render text");
        requestRichTextItemToBeUpdates();
    }, [cardNameRichText, cardTextRichTextHtml]);

    // Card Names
    // ----------
    // Absolute Serenity
    // Accident at the Vineyard
    // Adventurer's Insignia
    // Adventurer's Last Stand
    // Allard's Shout
    // Baby Giant Salamander
    // Backstab
    // Balancing the Scales
    // Barrage
    // Black Market Dealings
    // Blessing of Spirit Lake
    // Burt, the Cardkoi
    // Chain of Binding
    // Chrono Reversal
    // Climbing Tourmon's Wall
    // Consuming Darkness
    // Crescent Lightning
    // Crushing Earth
    // Curse of the Triclops
    // Dance of the Festival
    // Dark Priest's Necklace
    // Demon's Horn
    // Divine Hammer
    // Dungeons of Dawnbrook
    // Duplication
    // Endless Assault
    // Expedition to Ironar
    // Fade to Dust
    // Feathershark Robe
    // Flash Cut
    // Forger's Blessing
    // Friendship in the Trees
    // Frozen Spear
    // Golden Pyramid
    // Gourd of the South
    // Governor's Request
    // Guard Counter
    // Guardsman's Watch
    // Gust of the Heron
    // Heal
    // Heron's Graveyard
    // Horned Knight Armor
    // Impale
    // Iron Whisker
    // Judgement
    // Landslide
    // Lemon or Pickle?
    // Lights of the Everfrost
    // Lozendar's Crown
    // Mahkotta Market
    // Marauder's Hammer
    // Merchant's Acquisition
    // Mirage at Sheoland
    // Moon Slash
    // Nevil, the Evil Eye
    // Northern Creek Campfire
    // Northerner's Axe
    // Ocean's Ire
    // Pack of Scalemanders
    // Paladin's Chestplate
    // Pond Guardian
    // Pond of Greed
    // Rainbow Feather's Descent
    // Ranger's Garb
    // Robe of Shadows
    // Robe of the Phoenix
    // Rod of Whiskering
    // Run for Cover
    // Sandshark Ambush
    // Settlement of the Dead
    // Shadow Spirit's Tears
    // Shadows in the Sun
    // Shield of Wings
    // Shine of the Star Spirit
    // Shrouded Valley
    // Silvermist Rain
    // Slicing Sands
    // Star Spirit
    // Strategist's Cap
    // Strike
    // Swamp Frog's Robe
    // The Academia's Knowledge
    // The Forbidden Scroll
    // The Long Light
    // The Price of Freedom
    // The World Map
    // Treasure Crab
    // Water Shuriken
    // Wind Blade
    // Windless Summit's Secret

    const [cardTextCardNameSelect, setCardTextCardNameSelect] = useState(
        [
            { text: "Absolute Serenity", value: "Absolute Serenity" },
            { text: "Accident at the Vineyard", value: "Accident at the Vineyard" },
            { text: "Adventurer's Insignia", value: "Adventurer's Insignia" },
            { text: "Adventurer's Last Stand", value: "Adventurer's Last Stand" },
            { text: "Allard's Shout", value: "Allard's Shout" },
            { text: "Baby Giant Salamander", value: "Baby Giant Salamander" },
            { text: "Backstab", value: "Backstab" },
            { text: "Balancing the Scales", value: "Balancing the Scales" },
            { text: "Barrage", value: "Barrage" },
            { text: "Black Market Dealings", value: "Black Market Dealings" },
            { text: "Blessing of Spirit Lake", value: "Blessing of Spirit Lake" },
            { text: "Burt, the Cardkoi", value: "Burt, the Cardkoi" },
            { text: "Chain of Binding", value: "Chain of Binding" },
            { text: "Chrono Reversal", value: "Chrono Reversal" },
            { text: "Climbing Tourmon's Wall", value: "Climbing Tourmon's Wall" },
            { text: "Consuming Darkness", value: "Consuming Darkness" },
            { text: "Crescent Lightning", value: "Crescent Lightning" },
            { text: "Crushing Earth", value: "Crushing Earth" },
            { text: "Curse of the Triclops", value: "Curse of the Triclops" },
            { text: "Dance of the Festival", value: "Dance of the Festival" },
            { text: "Dark Priest's Necklace", value: "Dark Priest's Necklace" },
            { text: "Demon's Horn", value: "Demon's Horn" },
            { text: "Divine Hammer", value: "Divine Hammer" },
            { text: "Dungeons of Dawnbrook", value: "Dungeons of Dawnbrook" },
            { text: "Duplication", value: "Duplication" },
            { text: "Endless Assault", value: "Endless Assault" },
            { text: "Expedition to Ironar", value: "Expedition to Ironar" },
            { text: "Fade to Dust", value: "Fade to Dust" },
            { text: "Feathershark Robe", value: "Feathershark Robe" },
            { text: "Flash Cut", value: "Flash Cut" },
            { text: "Forger's Blessing", value: "Forger's Blessing" },
            { text: "Friendship in the Trees", value: "Friendship in the Trees" },
            { text: "Frozen Spear", value: "Frozen Spear" },
            { text: "Golden Pyramid", value: "Golden Pyramid" },
            { text: "Gourd of the South", value: "Gourd of the South" },
            { text: "Governor's Request", value: "Governor's Request" },
            { text: "Guard Counter", value: "Guard Counter" },
            { text: "Guardsman's Watch", value: "Guardsman's Watch" },
            { text: "Gust of the Heron", value: "Gust of the Heron" },
            { text: "Heal", value: "Heal" },
            { text: "Heron's Graveyard", value: "Heron's Graveyard" },
            { text: "Horned Knight Armor", value: "Horned Knight Armor" },
            { text: "Impale", value: "Impale" },
            { text: "Iron Whisker", value: "Iron Whisker" },
            { text: "Judgement", value: "Judgement" },
            { text: "Landslide", value: "Landslide" },
            { text: "Lemon or Pickle?", value: "Lemon or Pickle?" },
            { text: "Lights of the Everfrost", value: "Lights of the Everfrost" },
            { text: "Lozendar's Crown", value: "Lozendar's Crown" },
            { text: "Mahkotta Market", value: "Mahkotta Market" },
            { text: "Marauder's Hammer", value: "Marauder's Hammer" },
            { text: "Merchant's Acquisition", value: "Merchant's Acquisition" },
            { text: "Mirage at Sheoland", value: "Mirage at Sheoland" },
            { text: "Moon Slash", value: "Moon Slash" },
            { text: "Nevil, the Evil Eye", value: "Nevil, the Evil Eye" },
            { text: "Northern Creek Campfire", value: "Northern Creek Campfire" },
            { text: "Northerner's Axe", value: "Northerner's Axe" },
            { text: "Ocean's Ire", value: "Ocean's Ire" },
            { text: "Pack of Scalemanders", value: "Pack of Scalemanders" },
            { text: "Paladin's Chestplate", value: "Paladin's Chestplate" },
            { text: "Pond Guardian", value: "Pond Guardian" },
            { text: "Pond of Greed", value: "Pond of Greed" },
            { text: "Rainbow Feather's Descent", value: "Rainbow Feather's Descent" },
            { text: "Ranger's Garb", value: "Ranger's Garb" },
            { text: "Robe of Shadows", value: "Robe of Shadows" },
            { text: "Robe of the Phoenix", value: "Robe of the Phoenix" },
            { text: "Rod of Whiskering", value: "Rod of Whiskering" },
            { text: "Run for Cover", value: "Run for Cover" },
            { text: "Sandshark Ambush", value: "Sandshark Ambush" },
            { text: "Settlement of the Dead", value: "Settlement of the Dead" },
            { text: "Shadow Spirit's Tears", value: "Shadow Spirit's Tears" },
            { text: "Shadows in the Sun", value: "Shadows in the Sun" },
            { text: "Shield of Wings", value: "Shield of Wings" },
            { text: "Shine of the Star Spirit", value: "Shine of the Star Spirit" },
            { text: "Shrouded Valley", value: "Shrouded Valley" },
            { text: "Silvermist Rain", value: "Silvermist Rain" },
            { text: "Slicing Sands", value: "Slicing Sands" },
            { text: "Star Spirit", value: "Star Spirit" },
            { text: "Strategist's Cap", value: "Strategist's Cap" },
            { text: "Strike", value: "Strike" },
            { text: "Swamp Frog's Robe", value: "Swamp Frog's Robe" },
            { text: "The Academia's Knowledge", value: "The Academia's Knowledge" },
            { text: "The Forbidden Scroll", value: "The Forbidden Scroll" },
            { text: "The Long Light", value: "The Long Light" },
            { text: "The Price of Freedom", value: "The Price of Freedom" },
            { text: "The World Map", value: "The World Map" },
            { text: "Treasure Crab", value: "Treasure Crab" },
            { text: "Water Shuriken", value: "Water Shuriken" },
            { text: "Wind Blade", value: "Wind Blade" },
            { text: "Windless Summit's Secret", value: "Windless Summit's Secret" },
            // Expansion 1
            { text: "Hierophant's Command", value: "Hierophant's Command" },
            { text: "The Priestess' Prophecy", value: "The Priestess' Prophecy" },
            { text: "The Ruined Tower", value: "The Ruined Tower" },
            { text: "Chariot of Tides", value: "Chariot of Tides" },
            { text: "The Wandering Fool", value: "The Wandering Fool" },
            { text: "The Path of Temperance", value: "The Path of Temperance" },
            { text: "Hope of the Moon", value: "Hope of the Moon" },
            { text: "Burning Sun", value: "Burning Sun" },
            { text: "Justice on the Battlefield", value: "Justice on the Battlefield" },
            { text: "Wheel of Fortune", value: "Wheel of Fortune" },
            { text: "The Way of the World", value: "The Way of the World" },
            { text: "Love thy Enemy", value: "Love thy Enemy" },
            { text: "Love thy Self", value: "Love thy Self" },
            { text: "Merchant's Bird", value: "Merchant's Bird" },
            { text: "Deal with the Devil", value: "Deal with the Devil" },
            { text: "Robe of the Empress", value: "Robe of the Empress" },
            { text: "Alchemist's Glare", value: "Alchemist's Glare" },
            { text: "The Guiding Star", value: "The Guiding Star" },
            { text: "The Magician's Sleeve", value: "The Magician's Sleeve" },
            { text: "The Emperor's Crown", value: "The Emperor's Crown" },
            { text: "Emblem of Strength", value: "Emblem of Strength" },
            { text: "Bells of Judgement", value: "Bells of Judgement" },
            { text: "The Fortune Teller's Orb", value: "The Fortune Teller's Orb" },
            { text: "Scrying Glass", value: "Scrying Glass" },
            { text: "Heart Piercer", value: "Heart Piercer" },
            { text: "The Hermit Fisherman", value: "The Hermit Fisherman" },
            { text: "The Hanging Whisker", value: "The Hanging Whisker" },
            { text: "Death on the River", value: "Death on the River" }
        ]
    );

    const [cardTextToCardEffectText, setCardTextToCardEffectText] = useState(
        [
            { text: "Adventurer's Insignia", value: "During your turn, you may **DESTROY** this equipped card to **DRAW** (2). If an opponent **DESTROYS** this equipped card, **DRAW** (1)." },
            { text: "Curse of the Triclops", value: "You cannot use Attack cards this turn but you may add 1 Attack card of your choice from the Discard Pile to your hand, if possible." },
            { text: "Fade to Dust", value: "**DISCARD (1): Target a player & DESTROY (1).**" },
            { text: "Pond Guardian", value: "While this card is equipped, you may **DISCARD** (1) to **DRAW** (1) once per turn, during your turn. This effect may be used the same turn it is played." },
            { text: "Divine Hammer", value: "**WOUND (1) & HEAL (1), if possible.**" },
            { text: "Strike", value: "**WOUND (1). Basic Attack.**" },
            { text: "Northern Creek Campfire", value: "No players can target you with Attack cards until your next turn." },
            { text: "Ranger's Garb", value: "Basic Item." },
            { text: "Iron Whisker", value: "**DISCARD (1) to add a card of the same type from the Discard Pile to your hand. If you SACRIFICE (1), you may add any card from the Discard Pile, regardless of type, to your hand instead.**" }
        ]
    );

    // Handling Card Names -----------------------------------------------------------------------]

    



    // Capture today's date 
    const current = new Date();
    const date = `${current.getFullYear()}_${current.getMonth()+1}_${current.getDate()}`;
    //console.log("Date=" + date);

    // Init variable from components props --------------------------------------------------

    // Store the list of available background for this session
    // This will also be augmented through upload   
    const [availableBackground, setAvailableBackground] = useState(props.availableBackground);
    
    // STore custom assets uploaded by the user 
    const [availableAssets, setAvailableAssets] = useState([]);
    
    // Store the list of available accessories 
    const [availableAccessories1] = useState(props.availableAccessories1);
    const [availableAccessories2] = useState(props.availableAccessories2);

    // Slicers for each type of assets that we want to put in a Carousel on the UI
    const [availableCowsSlices, setAvailableCowsSlices] = useState([]);
    const [availablePartner1Slices, setAvailablePartner1Slices] = useState([]);
    const [availablePartner2Slices, setAvailablePartner2Slices] = useState([]);
    const [availableAccessories1Slices, setAvailableAccessories1Slices] = useState([]);
    const [availableAccessories2Slices, setAvailableAccessories2Slices] = useState([]);

    // Collection assets
    // Loaded though a useEffect()
    const [myCows, setMyCows] = useState(props.myAssets);
    const collectionAssetsGenerationFunction = props.collectionAssets;
    const [availableCows, setAvailableCows] = useState(collectionAssetsGenerationFunction());
    const [accordionDefaultActiveKey] = useState("11");       // Key for the UI to display the default pannel

    // Partner assets
    // Made of 0... n array per partner 
    const partner1AssetGenerationFunction = props.partnerAssets[0];
    const partner2AssetGenerationFunction = props.partnerAssets[1];
    const [allPartnerAssets, setAllPartnerAssets] = useState([partner1AssetGenerationFunction(), partner2AssetGenerationFunction()]);
    
    // Panel display status
    const accessories1PannelWalletRequired = props.displayItemConfig.accessories1 === "walletOnly";
    const accessories2PannelWalletRequired = props.displayItemConfig.accessories2 === "walletOnly";
    //const partner1PannelWalletRequired = props.displayItemConfig.partner1 === "walletOnly";
    //const partner2PannelWalletRequired = props.displayItemConfig.partner2 === "walletOnly";
    const canDisplayAccessories1Panel = (props.displayItemConfig.accessories1 !== "never") && (!accessories1PannelWalletRequired || (props.isCowOwner && accessories1PannelWalletRequired));
    const canDisplayAccessories2Panel = (props.displayItemConfig.accessories2 !== "never") && (!accessories2PannelWalletRequired || (props.isCowOwner && accessories2PannelWalletRequired));
    const canDisplayPartner1Panel = props.displayItemConfig.partner1 === "always";
    const canDisplayPartner2Panel = props.displayItemConfig.partner2 === "always";
    // console.log("accessories1PannelWalletRequired=" + accessories1PannelWalletRequired); console.log("accessories2PannelWalletRequired=" + accessories2PannelWalletRequired);
    // console.log("canDisplayAccessories1Panel=" + canDisplayAccessories1Panel); console.log("canDisplayAccessories2Panel=" + canDisplayAccessories2Panel);
    
    
    // Wallet data
    const wallet = props.wallet;
    const walletConnect = props.walletConnect;
    const walletDisconnect = props.walletDisconnect;


    // Page local variables --------------------------------------------------
    
    // Do we have a selected layer on the canva
    const [isSelectedLayerOnCanvas, setIsSelectedLayerOnCanvas] = useState(false);

    // Search query to let the user select which asset he wants 
    const [searchQueryAssetCollection, setSearchQueryAssetCollection] = useState(null);
    const [searchQueryPartner1Collection, setSearchQueryPartner1Collection] = useState(null);
    const [searchQueryPartner2Collection, setSearchQueryPartner2Collection] = useState(null);

    const allowCheckUserWallet = props.allowCheckUserWallet;
    const allowAssetSelection = props.allowAssetSelection;
    const allowAssetReRollConfig = props.allowAssetReRollConfig;
    
    // For about modal
    const [instructionsModalShow, setInstructionsModalShow] = useState(false);
    const handleInstructionsModalClose = () => setInstructionsModalShow(false);
    const handleInstructionsModalShow = () => setInstructionsModalShow(true);



    // Retrieve items from context --------------------------------------------------
    // Mavigation functions
    const { 
        isSelectedCowOnCanvas, setIsSelectedCowOnCanvas,        // TODO: Move somewhere else
    } = useSharedNavigationFunctions();
    // Global nav
    const { 
        // selectedNavItem, 
        // setOwnerAvailableCows,
        // setOwnerAvailableCowsNFT,
        // setHasUserSelectedACow,
        ownerWalletAddress, setOwnerWalletAddress,      // User wallet address to prevent querying user collection multiple time 
        // setOpenseaCollectionData
    } = useSharedNavigationPageGlobalState();
    // UIFunctions functions
    const { 
        GenericBootstrapAccordionToggle
    } = useSharedUIFunctions();

    // Retrieve items from context --------------------------------------------------
    

    // useEffect() declarations -----------------------------------------------------
    // Resize the stage based on screen size
    // Trigger upon page load and when user resize
    useEffect(() => { 
        //let isMounted = true;               // note mutable flag 
        //if (isMounted) {
            fitStageIntoParentContainer();
            window.addEventListener('resize', fitStageIntoParentContainer);
        //}
        return () => {
            //isMounted = false;
            window.removeEventListener('resize', fitStageIntoParentContainer);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Initialize the context 
    // Setup the myCows / availableCows based on ownership 
    useEffect(() => {
        if (props.isCowOwner) {
           // console.log("props.isCowOwner return",props.ownerAvailableCows);
           //setAccordionDefaultActiveKey("10");
           setMyCows(props.myAssets);
        } else {
            setMyCows([]);
            //setAccordionDefaultActiveKey("11");
        }
    }, [props]);

    // Split the list of available collection assets into small chunk
    // So we can display them in an carousel 
    useEffect(() => {
        const rows = availableCows.reduce(function (rows, key, index) { 
            return (index % 8 === 0 ? rows.push([key]) 
              : rows[rows.length-1].push(key)) && rows;
        }, []);
        setAvailableCowsSlices(rows);
    }, [availableCows]);
    // Split the list of available accessories into small chunk
    // So we can display them in an carousel 
    useEffect(() => {
        //console.log(availableAccessories1);
        if (availableAccessories1 != null) {
            const rows = availableAccessories1.reduce(function (rows, key, index) { 
                return (index % 8 === 0 ? rows.push([key]) 
                : rows[rows.length-1].push(key)) && rows;
            }, []);
            setAvailableAccessories1Slices(rows);
        }
    }, [availableAccessories1]);
    useEffect(() => {
        if (availableAccessories2 != null) {
            const rows = availableAccessories2.reduce(function (rows, key, index) { 
                return (index % 8 === 0 ? rows.push([key]) 
                : rows[rows.length-1].push(key)) && rows;
            }, []);
            setAvailableAccessories2Slices(rows);
        }   
    }, [availableAccessories2]);
    // Split the list of available partners assets into small chunk
    // So we can display them in an carousel 
    useEffect(() => {
        if (allPartnerAssets != null) {
            const rowsPartner1 = allPartnerAssets[0].reduce(function (rows, key, index) { 
                return (index % 8 === 0 ? rows.push([key]) 
                : rows[rows.length-1].push(key)) && rows;
            }, []);
            const rowsPartner2 = allPartnerAssets[1].reduce(function (rows, key, index) { 
                return (index % 8 === 0 ? rows.push([key]) 
                : rows[rows.length-1].push(key)) && rows;
            }, []);
            setAvailablePartner1Slices(rowsPartner1);
            setAvailablePartner2Slices(rowsPartner2);
        } 
    }, [allPartnerAssets])

    // // Delayed refresh upon background selection
    // const [triggerTimeoutStageRefresh, setTriggerTimeoutStageRefresh] = useState(0);
    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         //console.log("Timeout reach. Calling fitStageIntoParentContainer...");
    //         fitStageIntoParentContainer();
    //     }, 10);
    //     return () => clearTimeout(timer);

    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [triggerTimeoutStageRefresh]);

    // Delayed refresh upon download button click
    const [triggerTimeoutDownloadAssetRefresh, setTriggerTimeoutDownloadAssetRefresh] = useState(0);
    useEffect(() => {
        const timer = setTimeout(() => {
            if (triggerTimeoutDownloadAssetRefresh >0 ) {
                const uri = stageRef.current.toDataURL({ pixelRatio: 3 });
                //console.log("Exporting image:" + uri);
                downloadURI(uri, props.labelsConfig.collectionShortName + '_Card_' + date + '.png');
            }
        }, 500);
        return () => clearTimeout(timer);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [triggerTimeoutDownloadAssetRefresh, date]);
    // useEffect() declarations -----------------------------------------------------
    




    // Local Functions --------------------------------------------------
    
    // Function that return either all or portion of 
    // available background for the editor 
    const getAvailableBackground = (index) => {
        if (index !== null) {
            return availableBackground[index];
        } else {
            return availableBackground;
        }
    }

    // Function that add a new cow to the existing selection
    // The cow to be added is entered by the user
    // We check that the cow is a valid number that exists
    const performSearchQueryAssetCollection = () => {

        //console.log("searchQueryAssetCollection=", searchQueryAssetCollection);
        if (searchQueryAssetCollection === null) {
            console.error("No search query provided");
        } else {
            if (props.assetSearchFunction !== null) {

                const assetQueryString = searchQueryAssetCollection;
                //console.log("in function with customCow=" + cowId);

                // Custom function that perform search for the collection
                const result = props.assetSearchFunction(assetQueryString, props.assetCollectionMetadata, "collection");
                if (result !== null) { 
                    let updatedArray = [];
                    // Start with the results
                    for (var i = 0; i<result.length; i++) {
                        updatedArray.push(result[i]);
                    }
                    // // Add the previous results (if space is left)
                    // for (var i = 0; i<(availableCows.length-result.length); i++) {
                    //     updatedArray.push(availableCows[i]);
                    // }
                    setAvailableCows(updatedArray);

                } else {
                    console.log("No match for assetQueryString=" + assetQueryString );
                }

            } else {
                console.error("Need to implement custom function to search asset for this collection!");
            }
        }
        
    }

    // Method that intercept input value change
    // This is use for letting the user changing the cow
    const updateInputValueForCollectionSelector = (evt) => {
        //console.log("We are updating input value to:" + val);
        const val = evt.target.value;
        setSearchQueryAssetCollection(val);
    }


    // Function that perform a new cow to the existing selection
    // The cow to be added is entered by the user
    // We check that the cow is a valid number that exists
    const performSearchQueryPartner1Collection = () => {

        //console.log("customCowNumberToAddToCollection=", customCowNumberToAddToCollection);
        if (searchQueryPartner1Collection === null) {
            console.error("No search query provided");
        } else {
            if (props.assetSearchFunction !== null) {

                const assetQueryString = searchQueryPartner1Collection;
                //console.log("in function with customCow=" + cowId);

                // Custom function that perform search for the collection
                const result = props.assetSearchFunction(assetQueryString, props.partner1CollectionMetadata, "partner1");
                if (result !== null) { 
                    let updatedArray = [];
                    // Start with the results
                    for (var i = 0; i<result.length; i++) {
                        updatedArray.push(result[i]);
                    }
                    // // Add the previous results (if space is left)
                    // for (var i = 0; i<(availableCows.length-result.length); i++) {
                    //     updatedArray.push(availableCows[i]);
                    // }
                    setAllPartnerAssets([updatedArray, partner2AssetGenerationFunction()]);

                } else {
                    //console.log("No match for assetQueryString=" + assetQueryString );
                }

            } else {
                console.error("Need to implement custom function to search asset for this partner 1 collection!");
            }
        }
        
    }

    // Method that intercept input value change
    // This is use for letting the user specify the name of the card
    // isCustom is set to true when the user enter a custom card name (to differential if the action is done via dropdown or manual input)
    const updateInputValueForCardProperties = (val, property, isCustom) => {
        //console.log("updateInputValueForCardProperties: We are updating input value to:" + val + " for property:" + Property);
        let updatedText = "";
        switch(property) {
            case 'cardTextTitle':
              setCardTextTitle(val);
              return;
            case 'cardTextCardName':
                if (isCustom) {
                    setCardTextName(val);
                }
                updatedText = "<strong>SIGNATURE:</strong> " + val;
                //setCardTextCardName(updatedCardName);
                setCardNameRawText("**SIGNATURE:** " + val);
                setCardNameRichText(updatedText
                    //, requestTextCardNameUpdate()
                );

                // This will likely fail if the user set the card name manually
                const cardTextEffect = fetchCardEffectFromCardTextValue(val);
                if (cardTextEffect !== null) {

                    const updatedEffect = cardTextEffect.replace(/\*\*(.*?)\*\*|__(.*?)__/g, function(match, boldText, italicText) {
                        if (boldText) {
                          return '<strong>' + boldText + '</strong>';
                        }
                        if (italicText) {
                          return '<i>' + italicText + '</i>';
                        }
                    });

                    //let updatedEffect = cardTextEffect.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
                    //updatedEffect = updatedEffect.replace(/__(.*?)__/g, "<i>$1</i>");
                    setCardTextRawText(cardTextEffect);
                    setCardTextRichTextHtml(updatedEffect);
                    setCardTextCardEffect(cardTextEffect);
                }
              return;
            case 'cardTextCardEffect':
                setCardTextCardEffect(val);
                updatedText = val.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
                //setCardTextRichText(val);
                setCardTextRawText(val);
                setCardTextRichTextHtml(updatedText);
                console.log("updateInputValueForCardProperties: update text from " + val + " to " + updatedText);
              return;
            case 'cardTextDetails':
                setCardTextDetails(val);
              return;
            default:
              console.error("updateInputValueForCardProperties: INVALID property value: " + property)
        }
        
    }


    

    // Method that intercept input value change
    // This is use for letting the user changing the cow
    const updateInputValueForPartner1Selector = (evt) => {
        //console.log("We are updating input value to:" + val);
        const val = evt.target.value;
        setSearchQueryPartner1Collection(val);
    }

    // Function that perform a new cow to the existing selection
    // The cow to be added is entered by the user
    // We check that the cow is a valid number that exists
    const performSearchQueryPartner2Collection = () => {

        //console.log("customCowNumberToAddToCollection=", customCowNumberToAddToCollection);
        if (searchQueryPartner2Collection === null) {
            console.error("No search query provided");
        } else {
            if (props.assetSearchFunction !== null) {

                const assetQueryString = searchQueryPartner2Collection;
                //console.log("in function with customCow=" + cowId);

                // Custom function that perform search for the collection
                const result = props.assetSearchFunction(assetQueryString, props.partner2CollectionMetadata, "partner2");
                if (result !== null) { 
                    let updatedArray = [];
                    // Start with the results
                    for (var i = 0; i<result.length; i++) {
                        updatedArray.push(result[i]);
                    }
                    // // Add the previous results (if space is left)
                    // for (var i = 0; i<(availableCows.length-result.length); i++) {
                    //     updatedArray.push(availableCows[i]);
                    // }
                    setAllPartnerAssets([partner1AssetGenerationFunction(), updatedArray]);

                } else {
                    //console.log("No match for assetQueryString=" + assetQueryString );
                }

            } else {
                console.error("Need to implement custom function to search asset for this partner 2 collection!");
            }
        }
        
    }

    // Method that intercept input value change
    // This is use for letting the user changing the cow
    const updateInputValueForPartner2Selector = (evt) => {
        //console.log("We are updating input value to:" + val);
        const val = evt.target.value;
        setSearchQueryPartner2Collection(val);
    }





    // -------------------
    // EXTERNAL COMPONENTS
    // -------------------

    const WalletConnectionButtons = () => {

        return (

            <>
            <button title="Connect with your Metamask" onClick={() => walletConnect('injected')}
                className="mx-1 mt-1 mb-1"
                style={{
                        backgroundImage: `url("data:image/svg+xml;base64,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")`, 
                        backgroundColor: 'white',
                        backgroundRepeat: 'no-repeat', 
                        borderRadius: '7px',
                        border: '1px black solid', 
                        fontSize: '1em' 
                    }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Metamask       
            </button> 
            <button title="Connect with your Coinbase Wallet" onClick={() => walletConnect('walletlink')}
                className="mx-1 mt-1 mb-1"
                style={{
                        backgroundImage: `url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI4IiBoZWlnaHQ9IjI4IiBmaWxsPSIjMkM1RkY2Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQgMjMuOEMxOS40MTI0IDIzLjggMjMuOCAxOS40MTI0IDIzLjggMTRDMjMuOCA4LjU4NzYxIDE5LjQxMjQgNC4yIDE0IDQuMkM4LjU4NzYxIDQuMiA0LjIgOC41ODc2MSA0LjIgMTRDNC4yIDE5LjQxMjQgOC41ODc2MSAyMy44IDE0IDIzLjhaTTExLjU1IDEwLjhDMTEuMTM1OCAxMC44IDEwLjggMTEuMTM1OCAxMC44IDExLjU1VjE2LjQ1QzEwLjggMTYuODY0MiAxMS4xMzU4IDE3LjIgMTEuNTUgMTcuMkgxNi40NUMxNi44NjQyIDE3LjIgMTcuMiAxNi44NjQyIDE3LjIgMTYuNDVWMTEuNTVDMTcuMiAxMS4xMzU4IDE2Ljg2NDIgMTAuOCAxNi40NSAxMC44SDExLjU1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==")`, 
                        backgroundColor: 'white',
                        backgroundRepeat: 'no-repeat', 
                        borderRadius: '7px',
                        border: '1px black solid', 
                        fontSize: '1em',
                    }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Coinbase
                
            </button> 
            <button title="Connect with your WalletConnect" onClick={() => walletConnect('walletconnect')}
                className="mx-1 mt-1 mb-1"
                style={{
                        backgroundImage: `url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI4IiBoZWlnaHQ9IjI4IiBmaWxsPSIjM0I5OUZDIi8+CjxwYXRoIGQ9Ik04LjM4OTY5IDEwLjM3MzlDMTEuNDg4MiA3LjI3NTM4IDE2LjUxMTggNy4yNzUzOCAxOS42MTAzIDEwLjM3MzlMMTkuOTgzMiAxMC43NDY4QzIwLjEzODIgMTAuOTAxNyAyMC4xMzgyIDExLjE1MjkgMTkuOTgzMiAxMS4zMDc4TDE4LjcwNzYgMTIuNTgzNUMxOC42MzAxIDEyLjY2MDkgMTguNTA0NSAxMi42NjA5IDE4LjQyNzEgMTIuNTgzNUwxNy45MTM5IDEyLjA3MDNDMTUuNzUyMyA5LjkwODcgMTIuMjQ3NyA5LjkwODcgMTAuMDg2MSAxMi4wNzAzTDkuNTM2NTUgMTIuNjE5OEM5LjQ1OTA5IDEyLjY5NzMgOS4zMzM1IDEyLjY5NzMgOS4yNTYwNCAxMi42MTk4TDcuOTgwMzkgMTEuMzQ0MkM3LjgyNTQ3IDExLjE4OTMgNy44MjU0NyAxMC45MzgxIDcuOTgwMzkgMTAuNzgzMkw4LjM4OTY5IDEwLjM3MzlaTTIyLjI0ODUgMTMuMDEyTDIzLjM4MzggMTQuMTQ3NEMyMy41Mzg3IDE0LjMwMjMgMjMuNTM4NyAxNC41NTM1IDIzLjM4MzggMTQuNzA4NEwxOC4yNjQ1IDE5LjgyNzdDMTguMTA5NiAxOS45ODI3IDE3Ljg1ODQgMTkuOTgyNyAxNy43MDM1IDE5LjgyNzdDMTcuNzAzNSAxOS44Mjc3IDE3LjcwMzUgMTkuODI3NyAxNy43MDM1IDE5LjgyNzdMMTQuMDcwMiAxNi4xOTQ0QzE0LjAzMTQgMTYuMTU1NyAxMy45Njg2IDE2LjE1NTcgMTMuOTI5OSAxNi4xOTQ0QzEzLjkyOTkgMTYuMTk0NCAxMy45Mjk5IDE2LjE5NDQgMTMuOTI5OSAxNi4xOTQ0TDEwLjI5NjYgMTkuODI3N0MxMC4xNDE3IDE5Ljk4MjcgOS44OTA1MyAxOS45ODI3IDkuNzM1NjEgMTkuODI3OEM5LjczNTYgMTkuODI3OCA5LjczNTYgMTkuODI3NyA5LjczNTYgMTkuODI3N0w0LjYxNjE5IDE0LjcwODNDNC40NjEyNyAxNC41NTM0IDQuNDYxMjcgMTQuMzAyMiA0LjYxNjE5IDE0LjE0NzNMNS43NTE1MiAxMy4wMTJDNS45MDY0NSAxMi44NTcgNi4xNTc2MyAxMi44NTcgNi4zMTI1NSAxMy4wMTJMOS45NDU5NSAxNi42NDU0QzkuOTg0NjggMTYuNjg0MSAxMC4wNDc1IDE2LjY4NDEgMTAuMDg2MiAxNi42NDU0QzEwLjA4NjIgMTYuNjQ1NCAxMC4wODYyIDE2LjY0NTQgMTAuMDg2MiAxNi42NDU0TDEzLjcxOTQgMTMuMDEyQzEzLjg3NDMgMTIuODU3IDE0LjEyNTUgMTIuODU3IDE0LjI4MDUgMTMuMDEyQzE0LjI4MDUgMTMuMDEyIDE0LjI4MDUgMTMuMDEyIDE0LjI4MDUgMTMuMDEyTDE3LjkxMzkgMTYuNjQ1NEMxNy45NTI2IDE2LjY4NDEgMTguMDE1NCAxNi42ODQxIDE4LjA1NDEgMTYuNjQ1NEwyMS42ODc0IDEzLjAxMkMyMS44NDI0IDEyLjg1NzEgMjIuMDkzNiAxMi44NTcxIDIyLjI0ODUgMTMuMDEyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==")`, 
                        backgroundColor: 'white',
                        backgroundRepeat: 'no-repeat', 
                        borderRadius: '7px',
                        border: '1px black solid', 
                        fontSize: '1em'  
                    }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; WalletConnect 
            </button> 
            </>

        )

    };

    // Create a draggable image component 
    // That can also be rotated and resized 
    // Source: https://konvajs.org/docs/react/Transformer.html
    const DraggableAndResizableImage = ({ 
        shapeProps, 
        mode, 
        isSelected, 
        onSelect, 
        onChange, 
        image }) => {

        const [img] = useImage(image.src, 'Anonymous');

        // DEBUG
        console.log("shapeProps DUMP... ", shapeProps);
        console.log("mode=" + mode);

        const shapeRef = React.useRef(null);
        const trRef = React.useRef(null);

        // we need to attach transformer manually
        // when we select the shape 
        React.useEffect(() => {
            if (isSelected) {
                // Attaching the transformer here 
                trRef.current.nodes([shapeRef.current]);
                trRef.current.getLayer().batchDraw();
            }
        }, [isSelected]);

        let draggableStatus = null;
        // if (mode === "BACKGROUND_LAYER") {
        //     draggableStatus = false;
        // }
        if (mode === "COW_LAYER") {
            draggableStatus=true;
        }
        // if (mode === "TEXT_LAYER") {
        //     draggableStatus=true;
        // }

        console.log("Ready to render...");

        return (

            <>
            <div>Adding Image</div>
            
        <React.Fragment>

            <ImageKonva

                onClick={onSelect}
                onTap={onSelect}
                ref={shapeRef}
                key={"DraggableAndResizableImage_" + shapeProps.mykey}
                {...shapeProps}

                image={img}
                x={image.x}
                y={image.y}
                width={image.width}
                height={image.height}
                offsetX={image.width / 2}
                offsetY={image.height / 2}
                scaleX={image.scaleX}
                scaleY={image.scaleY}

                draggable={draggableStatus}
                onDragEnd={e => {
                    onChange({
                        ...shapeProps,
                        x: e.target.x(),
                        y: e.target.y(),
                    });
                    // state.isDragging = true;
                    // state.x = e.target.x();
                    // state.y = e.target.y();

                }} 
                onTransformEnd={(e) => {
                    // transformer is changing scale of the node
                    // and NOT its width or height
                    // but in the store we have only width and height
                    // to match the data better we will reset scale on transform end
                    const node = shapeRef.current;
                    const scaleX = Math.abs(node.scaleX());
                    const scaleY = Math.abs(node.scaleY());

                    // we will reset it back
                    // actually this looks like a bug
                    // so not enabling this
                    node.scaleX(1);
                    node.scaleY(1);

                    //console.log(shapeRef);
                    // console.log(node);
                    // console.log("scaleX: " + scaleX + "scaleY: " + scaleY);
                    // console.log("X: " + node.x() + "Y: " + node.y());
                    
                    // For some reason, if we've flipped the cow
                    // We need to add 180 degress to the rotation 
                    // to prevent the image to rotate (or flip on the Y axis)
                    // TODO: Investigate why this is an issue in the first place
                    let rotation = node.rotation();
                    if (node.attrs.flipped === true) {
                        rotation = (180 + node.rotation());
                    }
                    
                    onChange({
                        // Adding / removing attributes here 
                        // will not take affect until you update the method
                        // reference by onChange here
                        ...shapeProps,
                        x: node.x(),
                        y: node.y(),
                        // set minimal value
                        width: Math.max(5, node.width() * scaleX),
                        height: Math.max(node.height() * scaleY),
                        rotation: rotation,
                    });
                }}
                // onContextMenu={handleContextMenu}

            />

            {isSelected && (mode === "COW_LAYER") && (
                <Transformer
                    ref={trRef}
                    flipEnabled={false}
                    keepRatio={true}
                    anchorFill="pink"
                    borderStroke="pink"
                    borderStrokeWidth={4}
                    rotateAnchorOffset={30}
                    anchorSize={13}
                    anchorStroke="black"
                    borderDash={[3, 3]}
                    rotationSnaps = {[0, 90, 180, 270]}
                    enabledAnchors={['top-left', 'top-right', 'bottom-left', 'bottom-right']}        // Prevent changing ratio
                    boundBoxFunc={(oldBox, newBox) => {
                        // limit resize
                        if (newBox.width < 5 || newBox.height < 5) {
                        return oldBox;
                        }
                        return newBox;
                    }} 
            />)}

            {/* {isSelected && (mode === "BACKGROUND_LAYER") && (
                <Transformer
                    ref={trRef}
                    flipEnabled={false}
                    resizeEnabled={false}
                    rotateEnabled={false}
                    anchorFill="red"
                    borderStroke="red"
                    borderStrokeWidth={2}
                    anchorSize={13}
                    borderDash={[8]}
                    boundBoxFunc={(oldBox, newBox) => {
                        // limit resize
                        if (newBox.width < 5 || newBox.height < 5) {
                            return oldBox;
                        }
                        return newBox;
                    }} 
            />)} */}

        </React.Fragment>
        </>
        );
        
    };






    // LOAD DATA FOR EDITORS
    // *********************

    // Load list of background available to the user
    const [editorBackgroudList, setEditorBackgroudList] = useState(getAvailableBackground(null));

    // Load background Items
    const [selectedBackgroundId, setSelectedBackgroundId] = useState(0);        // Store currently selected background
    
    // For editor
    const dragUrl = React.useRef();
    const dragUrlId = React.useRef();
    const dragUrlHeight = React.useRef();
    const dragUrlWidth = React.useRef();
    
    const stageRef = React.useRef();
    const [nbAssetsOnCanvas, setNbAssetsOnCanvas] = useState(0);;
    
    // Handle transfor to resize images
    const [selectedShapeId, setSelectedShapeId] = React.useState(null);           // Which asset is selected?
    
    // Deselect all selected shapes 
    const checkDeselect = (e) => {
        handleUnselectCow();
    };





    // TEXT EDITOR CONTROLS
    // ********************

    const [isTextBeingEditedOnCanvas, setIsTextBeingEditedOnCanvas] = useState(false);
    const [isTextBeingSelectedOnCanvas, setIsTextBeingSelectedOnCanvas] = useState(false);

    // Turn on editing mode for the canvas
    const editSelectedTextToCanvas = () => {
        setIsTextBeingEditedOnCanvas(true);
    }

    // Change textAlign property of selected text 
    const alignText = (direction) => {

        // Fetch selectedElement
        const selectedElement = selectedShapeId;
        // Lookup the index value in the array
        // We don't do a simple array[index] since the index
        // value might not follow the array order once we start 
        // moving element up and down the layers 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        let layerItem = updateLayersArray.find(i => i.index === selectedElement);
        const layerItemIndex = updateLayersArray.indexOf(layerItem);

        // Check that we have selected a text elelement and not a background element
        if (canvasLayersOrdered.layers[0][layerItemIndex].mode === "TEXT_LAYER") {
            //console.log("alignText: found text element ", updateLayersArray[layerItemIndex]);
            updateLayersArray[layerItemIndex].textAlign = direction;
            const updatedCanvasLayersOrdered = {
                layers: [updateLayersArray]
            }
            setCanvasLayersOrdered(updatedCanvasLayersOrdered);
            
        } else {
            //console.log("We have not selected a text element!");
        }

    }

    /**
     * Update the font of the select text by a given increment (positive or negative)
     * @param {*} fontSizeIncrement the increment to add to the existing fontSize
     */
    const updateFontSize = (fontSizeIncrement) => {

        // Fetch selectedElement
        const selectedElement = selectedShapeId;

        // Lookup the index value in the array
        // We don't do a simple array[index] since the index
        // value might not follow the array order once we start 
        // moving element up and down the layers 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        let layerItem = updateLayersArray.find(i => i.index === selectedElement);
        const layerItemIndex = updateLayersArray.indexOf(layerItem);

        // Check that we have selected a text elelement and not a background element
        if (canvasLayersOrdered.layers[0][layerItemIndex].mode === "TEXT_LAYER") {
            //console.log("alignText: found text element ", updateLayersArray[layerItemIndex]);
            const currentSize = updateLayersArray[layerItemIndex].fontSize
            updateLayersArray[layerItemIndex].fontSize = currentSize + (currentSize * fontSizeIncrement);
            const updatedCanvasLayersOrdered = {
                layers: [updateLayersArray]
            }
            setCanvasLayersOrdered(updatedCanvasLayersOrdered);
            
        } else {
            //console.log("We have not selected a text element!");
        }

    }

    // Change textColor property of selected text 
    const updateTextColor = (color) => {

        // Fetch selectedElement
        const selectedElement = selectedShapeId;
        // Lookup the index value in the array
        // We don't do a simple array[index] since the index
        // value might not follow the array order once we start 
        // moving element up and down the layers 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        let layerItem = updateLayersArray.find(i => i.index === selectedElement);
        const layerItemIndex = updateLayersArray.indexOf(layerItem);

        // Check that we have selected a text elelement and not a background element
        if (canvasLayersOrdered.layers[0][layerItemIndex].mode === "TEXT_LAYER") {
            //console.log("alignText: found text element ", updateLayersArray[layerItemIndex]);
            updateLayersArray[layerItemIndex].textColor = color;
            const updatedCanvasLayersOrdered = {
                layers: [updateLayersArray]
            }
            setCanvasLayersOrdered(updatedCanvasLayersOrdered);
            
        } else {
            //console.log("We have not selected a text element!");
        }

    }


    // Add text area to canvas
    // From clicking the toolbar bar
    const addTextToCanvas = (e, defaultText, defaultColor) => {
        
        e.preventDefault();

        const textLength = defaultText.length;
        // 28 characters seems to be the right amount for 50 pixels in height 
        // after that we need to add more height 
        const textSizeMultiplier = textLength / 28;
        const textWidth = 200 / stageScale.x;
        const textHeight = (50 * textSizeMultiplier) / stageScale.y;
        
        let posX; let posY;
        posX = stageWidth / 2 / stageScale.x;
        posY = stageHeight / 2 / stageScale.y;
        //console.og ("DRAG x= " + posX + " y= " + posY);

        // add text
        const updatedCanvasLayersOrdered = {
            layers: [canvasLayersOrdered.layers[0].concat([
                {
                    //...stageRef.current.getPointerPosition(),
                    x: posX,
                    y: posY,
                    src: null,
                    mode: "TEXT_LAYER",
                    index: canvasLayersOrdered.layers[0].length, 
                    width: textWidth,
                    height: textHeight,
                    text: defaultText,
                    fontSize: 20 / stageScale.x,
                    fontWeight: "normal",
                    fontFamily: 'TextEditorFont',
                    textAlign: 'center',
                    textColor: defaultColor,         // Default color
                    scaleX: 1,
                    flipped: false,
                    rotation: 0     // No rotation by default
                }])]
        }
        
        // DEBUG
        //console.log("DUNMP canvasLayersOrdered after COW DROPPED: ", updatedCanvasLayersOrdered);
        setCanvasLayersOrdered(updatedCanvasLayersOrdered);
        setNbAssetsOnCanvas(nbAssetsOnCanvas+1);  // Track number of cow on canvas to generate unique id use for selection
        
        // Select the text
        setSelectedShapeId(canvasLayersOrdered.layers[0].length);
        setIsSelectedCowOnCanvas(false);
        setIsSelectedLayerOnCanvas(false);
        setIsTextBeingSelectedOnCanvas(true);
    }


    // Change textColor property of selected text 
    const updateTemplateLayerBackgroundColor = (color) => {

        // Copy the array before updating it 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        const layerItemIndex = 0;  // The first level is a blank canvas (need this for the preview)
                                   // The level above is the color of the tempalte 
        updateLayersArray[layerItemIndex].backgroundColor = color;
        updateLayersArray[layerItemIndex].mode = "TEMPLATE_COLOR_LAYER";
        const updatedCanvasLayersOrdered = {
            layers: [updateLayersArray]
        }
        //console.log(updateLayersArray);
        setCanvasLayersOrdered(updatedCanvasLayersOrdered);

    }



    // SETUP CANVAS
    // ************

    // Store the canvas state
    // This object contain all the layers (background layers + moos)
    // That are added on the canvas
    // Each item has the following properties
    //   - x
    //   - y
    //   - width
    //   - height
    //   - id
    const [canvasLayersOrdered, setCanvasLayersOrdered] = useState(
        {layers: [[]]}
    );

    // DEBUG
    //console.log("DUNMP canvasLayersOrdered after COW DROPPED: ", canvasLayersOrdered);
    
    // Canvas size
    const [stageWidth, setStageWidth] = useState(300);              // Default canvas width
    const [stageHeight, setStageHeight] = useState(420);            // Default canvas height
    const [stageScale, setStageScale] = useState({ x: 1, y: 1 });   // Default canvas scale 

    // // Selecting a different background
    // const changeBackgroundHandler = async ( imageSrc, imageId, imageEvent ) => {

    //     //console.log("changeBackgroundHandler: backgroundId=" + imageId);

    //     if (isAssetOnCanvas()) {
    //         const result = await 
    //         confirm("You are going to change the background but you have made change to the previous one. Are you sure you want to loose your previous creation and continue?"
    //         , {
    //             title: "Attention!",
    //             okText: "Let's go!",
    //             okButtonStyle: "success",
    //             cancelText: "Let me finish my previous creation",
    //             cancelButtonStyle: "danger"
    //         });
    //         if (result === true) {

    //             // If we specific an imageEvent, then we use
    //             // that source to fetch the asset width/height
    //             // This is used usually when upload your own asset
    //             // Since their size is not known until being render
    //             // on the preview pannel 
    //             if (imageEvent != null) {
    //                 const imageHeight = imageEvent.target.height;
    //                 const imageWidth = imageEvent.target.width;
    //                 //console.log("Width= " + imageWidth + " | Height= " + imageHeight );
    //                 editorBackgroudList[imageId][0].width = imageWidth;
    //                 editorBackgroudList[imageId][0].height = imageHeight;
    //             }
    //             setSelectedBackgroundId(imageId);
    //             resetCanvas(imageId);
    //             resetCardCanvas(imageId);
    //         }
    //     } else {

    //         // If we specific an imageEvent, then we use
    //         // that source to fetch the asset width/height
    //         // This is used usually when upload your own asset
    //         // Since their size is not known until being render
    //         // on the preview pannel 
    //         if (imageEvent != null) {
    //             const imageHeight = imageEvent.target.height;
    //             const imageWidth = imageEvent.target.width;
    //             //console.log("Width= " + imageWidth + " | Height= " + imageHeight );
    //             editorBackgroudList[imageId][0].width = imageWidth;
    //             editorBackgroudList[imageId][0].height = imageHeight;
    //         }
    //         setSelectedBackgroundId(imageId);
    //         resetCanvas(imageId);
    //         resetCardCanvas(imageId);
    //     }
    // }

    // // Reset Background Generator canvas with a specific backgroundId
    // const resetCanvas = ( imageId ) => {

    //     // reset the canvasLayer configuration
    //     const updatedCanvasLayersOrdered = {
    //         layers: [getAvailableBackground(imageId)]
    //     }
    //     setCanvasLayersOrdered(updatedCanvasLayersOrdered);
    //     setNbAssetsOnCanvas(0);
    //     setIsSelectedLayerOnCanvas(false);

    //     //console.log("changeBackgroundHandler() canvasLayersOrdered DUMP on backgroundChange event...");
    //     //console.log(canvasLayersOrdered);

    //     // Fetch the background image (which is the first layer)
    //     const sceneWidth  = updatedCanvasLayersOrdered.layers[0][0].width;
    //     const sceneHeight = updatedCanvasLayersOrdered.layers[0][0].height;
    
    //     // Resize the stage container accordingly 
    //     // console.log("resetCanvas() Need to update Stage size - x:" + sceneWidth + " y:" + sceneHeight);

    //     setStageWidth(sceneWidth);
    //     setStageHeight(sceneHeight);

    //     // Trigger a delayed stage refresh 
    //     setTriggerTimeoutStageRefresh(triggerTimeoutStageRefresh+1);
    //     // fitStageIntoParentContainer();
    // }

    // // Reset Background Generator canvas with a specific backgroundId
    // const resetCardCanvas = ( imageId ) => {

    //     // reset the canvasLayer configuration
    //     const updatedCanvasLayersOrdered = {
    //         layers: [getAvailableBackground(imageId)]
    //     }
    //     setCanvasLayersOrdered(updatedCanvasLayersOrdered);
    //     setNbAssetsOnCanvas(0);
    //     setIsSelectedLayerOnCanvas(false);

    //     //console.log("changeBackgroundHandler() canvasLayersOrdered DUMP on backgroundChange event...");
    //     //console.log(canvasLayersOrdered);

    //     // Fetch the background image (which is the first layer)
    //     const sceneWidth  = updatedCanvasLayersOrdered.layers[0][0].width;
    //     const sceneHeight = updatedCanvasLayersOrdered.layers[0][0].height;
    
    //     // Resize the stage container accordingly 
    //     // console.log("resetCardCanvas() Need to update Stage size - x:" + sceneWidth + " y:" + sceneHeight);

    //     setCardStageWidth(sceneWidth);
    //     setCardStageHeight(sceneHeight);

    //     // Trigger a delayed stage refresh 
    //     setTriggerTimeoutStageRefresh(triggerTimeoutStageRefresh+1);
    //     // fitStageIntoParentContainer();
    // }

    // Adjust the size of the stage to the container (useful when user reisze + at app startup)
    const fitStageIntoParentContainer = () => {
        // var container = document.querySelector('#cardStageContainer');
        // //console.log("layers OBJ", editorBackgroudList);
        
        // const fixSceneWidth = 300;
        // const fixSceneHeight = 420;

        // const sceneWidth = fixSceneWidth + 40;
        // const sceneHeight = fixSceneHeight + 40;

        // // now we need to fit stage into parent container
        // var containerWidth = container.offsetWidth;
 
        // // but we also make the full scene visible
        // // so we need to scale all objects on canvas
        // var scale = (containerWidth / sceneWidth)*0.9;

        // //console.log("Pulling sceneWidth=" + sceneWidth + " sceneHeight=" + sceneHeight);
        // //console.log("Pulling containerWidth=" + containerWidth + " scale=" + scale);
        // //console.log("Pulling selectedBackgroundId=" + selectedBackgroundId);
        
        // setStageWidth(sceneWidth * scale);
        // setStageHeight(sceneHeight * scale);

        // setCardStageWidth(sceneWidth * scale);
        // setCardStageHeight(sceneHeight * scale);
        // //console.log("Updated stageWidth -> " + sceneWidth * scale);
        // //console.log("Updated stageHeight -> " + sceneHeight * scale);
        
        // setStageScale({ x: scale, y: scale });
        // setCardStageScale({ x: scale, y: scale });



    }
    







    // UTILITY FUNCTIONS
    // *****************

    // Check if there is at least one cow on the canvas
    function isCowOnCanvas() {
        //console.log("isCowOnCanvas");
        const result = canvasLayersOrdered.layers[0];
        for (var i = 0; i < result.length; i++) {
            if (result[i].mode === "COW_LAYER") {
                //console.log("isCowOnCanvas - return TRUE");
                return true;
            }
        }
        //console.log("isCowOnCanvas - return FALSE");
        return false; 
    }

    // Check if there is at least one cow on the canvas
    function isTextOnCanvas() {
        //console.log("isCowOnCanvas");
        const result = canvasLayersOrdered.layers[0];
        for (var i = 0; i < result.length; i++) {
            if (result[i].mode === "TEXT_LAYER") {
                //console.log("isCoisTextOnCanvaswOnCanvas - return TRUE");
                return true;
            }
        }
        //console.log("isCowOnCanvas - return FALSE");
        return false; 
    }

    // Check if there is at least one cow on the canvas
    function isAssetOnCanvas() {
        return isCowOnCanvas() || isTextOnCanvas(); 
    }





    // TOGGLES ITEMS
    // ************

    // For Cards 
    const [toggleUIBackgroundSelector, setToggleUIBackgroundSelector] = useState(true);
    const [toggleUICowSelector, setToggleUICowSelector] = useState(true);





    // ASSETS MANAGEMNET
    // =================
    // Re-roll the asset specific as parameters
    // Walues are
    // - collection
    // - partner1
    // - partner2
    function reRollAssetCollection(mode) {
        //console.log("RerollAsset: MODE=" + mode);
        if (mode === "collection") {
            console.log("Regenerate collection assets...");
            setAvailableCows(collectionAssetsGenerationFunction());  
        }
        if (mode.startsWith("partner")) {
            //compute partner index
            const partnerIndex = mode.substr("partner".length, 1);
            // Rebuild reslt array (updating existing reference won't trigger state refresh)
            const result = [
                allPartnerAssets[0],
                allPartnerAssets[1]];
            let newGeneration = []
            if (partnerIndex == 1) {
                //console.log("Regenerate partner1 assets...");
                newGeneration = partner1AssetGenerationFunction();
            }
            if (partnerIndex == 2) {
                //console.log("Regenerate partner2 assets...");
                newGeneration = partner2AssetGenerationFunction();
            } 
            result[partnerIndex-1] = newGeneration;
            //console.log("partnerIndex: " + partnerIndex +  " mode: " + mode + " return", allPartnerAssets);
            //console.log("new generation run: ", newGeneration);
            //console.log("results: ", result);
            setAllPartnerAssets(result);
        }
    }


    // BUTTON ITEMS
    // ************

    // Export image
    // function from https://stackoverflow.com/a/15832662/512042
    function downloadURI(uri, name) {
        var link = document.createElement('a');
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const handleImageExport = () => {
        // Deselect any selected cow
        // To prevent anchor to be exported
        handleUnselectCow();

        // Timeout to wait for the unselection to complete 
        setTriggerTimeoutDownloadAssetRefresh(triggerTimeoutDownloadAssetRefresh+1);
    };

    // Delete the currently selected cow from the canvas
    const deleteSelectedAsset = () => {
       
        // Fetch selectedElement
        const selectedCowId = selectedShapeId;
        // Lookup the index value in the array
        // We don't do a simple array[index] since the index
        // value might not follow the array order once we start 
        // moving element up and down the layers 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        const layerItem = updateLayersArray.find(i => i.index === selectedCowId);
        const layerItemIndex = updateLayersArray.indexOf(layerItem);
        
        // Check that we have selected a cow and not a background element
        if (canvasLayersOrdered.layers[0][layerItemIndex].mode === "COW_LAYER" || canvasLayersOrdered.layers[0][layerItemIndex].mode === "TEXT_LAYER") {
            updateLayersArray.splice(layerItemIndex, 1);

            // Need to reprocess the array to reset the index accordingly
            // This is required if we do not delete the last element from the layer stack 
            for (var h=0; h<updateLayersArray.length; h++) {
                updateLayersArray[h].index = h;
            }

            const updatedCanvasLayersOrdered = {
                layers: [updateLayersArray]
            }
            setCanvasLayersOrdered(updatedCanvasLayersOrdered);

            // Deselect any selected cow
            handleUnselectCow();
        } else {
            //console.log("We have not selected a cow!");
        }
    };

    // // Delete all cows from cavans
    // const deleteAllCows = () => {

    //     // Reset the canvas without confirmation
    //     resetCanvas(selectedBackgroundId);

    //     // Deselect any selected cow
    //     handleUnselectCow();
    // }

    // Delete the currently selected cow from the canvas
    const flipSelectedCow = () => {
    
        // Fetch selectedElement
        const selectedCowId = selectedShapeId;
        // Lookup the index value in the array
        // We don't do a simple array[index] since the index
        // value might not follow the array order once we start 
        // moving element up and down the layers 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        let layerItem = updateLayersArray.find(i => i.index === selectedCowId);
        const layerItemIndex = updateLayersArray.indexOf(layerItem);

        // Check that we have selected a cow and not a background element
        if (canvasLayersOrdered.layers[0][layerItemIndex].mode === "COW_LAYER") {
            updateLayersArray[layerItemIndex].scaleX = -(updateLayersArray[layerItemIndex].scaleX);
            updateLayersArray[layerItemIndex].flipped = !(updateLayersArray[layerItemIndex].flipped);
            
            const updatedCanvasLayersOrdered = {
                layers: [updateLayersArray]
            }
            setCanvasLayersOrdered(updatedCanvasLayersOrdered);
        } else {
            //console.log("We have not selected a cow!");
        }
    };

    // Delete the currently selected cow from the canvas
    const bringSelectedShapeToFront = () => {

        // Fetch selectedElement
        const selectedCowId = selectedShapeId;
        //console.log("selectedCowId...");
        //console.log(selectedCowId);

        // Lookup the index value in the array
        // We don't do a simple array[index] since the index
        // value might not follow the array order once we start 
        // moving element up and down the layers 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        const layerItem = updateLayersArray.find(i => i.index === selectedCowId);
        const layerItemIndex = updateLayersArray.indexOf(layerItem);

        const removedLayer = updateLayersArray.splice(layerItemIndex, 1);

        //console.log("removedLayer...");
        //console.log(removedLayer);

        updateLayersArray.push(removedLayer[0]);
        // Rebuild the list of layers
        const updatedCanvasLayersOrdered = {
            layers: [updateLayersArray]
        }

        //console.log("bringSelectedShapeToFront...");
        //console.log(updatedCanvasLayersOrdered);

        setCanvasLayersOrdered(updatedCanvasLayersOrdered);

    };

    

    // Function to deselect cow
    // We are assuming we are calling this
    // Only if we know the selected item is a cow
    // If not, need to add logic to check for that
    const handleUnselectCow = () => {
        // Deselect any selected cow
        // To prevent anchor to be exported
        setSelectedShapeId(null);
        setIsSelectedCowOnCanvas(false);
        setIsSelectedLayerOnCanvas(false);
        setIsTextBeingEditedOnCanvas(false);
        setIsTextBeingSelectedOnCanvas(false);
    };



        
    /**
     * Replace the current PFP Image with a new one 
     * 
     * @param {*} src the location (URL) of the image to load 
     */
    const updateCardPfpImage = (src) => {
        //console.log("In load image with src=" + src);
        const image = new window.Image();
        image.src = src;
        image.crossOrigin = 'Anonymous';
        image.onload = () => {
            setCardPfpImage(image);
        }
    }
        
    // Add asset to canvas
    // Either from clicking on the asset on the area
    // or from dran-dropping to the canva area 
    const addAssetToCanvas = (e, assetData, ignorePointerPosition, alternativeCanvaImage = null, isUploadedAsset = false) => {
        e.preventDefault();

        // FOR ASSETS BEING UPLOADED 
        if (isUploadedAsset) {

            setIsPFPOnCanvasUploaded(isUploadedAsset);  // isUploadedAsset always === true 
            setIsPFPLegendSelected(false);

            // Reset the properties of the image 
            updateInputValueForUploadedPFPImageProperties(10, 'userUploadPFPPosX');
            updateInputValueForUploadedPFPImageProperties(10, 'userUploadPFPPosY');
            updateInputValueForUploadedPFPImageProperties(280, 'userUploadPFPWidth');
            updateInputValueForUploadedPFPImageProperties(328, 'userUploadPFPHeight');

            //console.log("addAssetToCanvas: MODE = UPLOADED ASSET");
            updateCardPfpImage(e.target.src);

        // FOR ASSETS BEING SELECTED 
        } else {

            //console.log("addAssetToCanvas: MODE = COLLECTION ASSET");

            // Fetch tokenId 
            const assetIndex = assetData.index;
            const assetTokenId = assetData.tokenId;
            
            // Fetch NFT Traits based on tokenId 
            const traits = props.assetTraitLookupFunction(assetTokenId, props.assetCollectionMetadata);
            // console.log("addAssetToCanvas: Trait for tokenId=" + assetTokenId + " are ", traits);

            updateCardPfpImage(e.target.src);
            // Updating PFP Color based on Origin trait value 
            let color = null;

            // If we are on 1:1, create custom logic
            if (traits[0].origin === "legend") {
                //console.log("addAssetToCanvas: We selected a 1:1");  
                setIsPFPOnCanvasUploaded(true);
                setIsPFPLegendSelected(true);

                // Set custom image size for 1:1
                //updateInputValueForUploadedPFPImageProperties(10, 'userUploadPFPPosX');
                //updateInputValueForUploadedPFPImageProperties(34, 'userUploadPFPPosY');
                //updateInputValueForUploadedPFPImageProperties(280, 'userUploadPFPWidth');
                //updateInputValueForUploadedPFPImageProperties(280, 'userUploadPFPHeight');

                //color = fetchPfpBackgroundColorFromTraitValue(traits[0].origin + "_" + assetTokenId);
            } else {
                setIsPFPOnCanvasUploaded(isUploadedAsset); // isUploadedAsset always === false
                setIsPFPLegendSelected(false);
                color = fetchPfpBackgroundColorFromTraitValue(traits[0].origin);
            }
            setPfpBackgroundColor(color);

            

            // Update Card Effect based on Equipment trait value
            // DISABLED as we instead use instead update card effect/ability based on card text 
            // const equipmentTrait = traits[0].equipment;
            // const cardTextEffect = fetchCardEffectFromEquipmentTraitValue(equipmentTrait);
            // setCardTextCardEffect("Detecting equipment value= " + equipmentTrait);

        }

        //console.log("addAssetToCanvas: setIsPFPOnCanvasUploaded=" + isPFPOnCanvasUploaded);
        //console.log("addAssetToCanvas: setIsPFPLegendSelected=" + isPFPLegendSelected);
             
    }



    // IMAGE UPLOADS
    // *************
    
    const [uploadBackground, setUploadBackground] = useState([]);
    function onUploadBackgroundImageChange(e) {
        setUploadBackground([...e.target.files]);
    }

    useEffect(() => {
        if (uploadBackground.length <1) {
            return;
        }
        let newImagesUrls = [];
        // We currently only loop this once since we only allow one
        // Image to be uploaded at a time from the UI
        uploadBackground.forEach(image =>  {
                const src = URL.createObjectURL(image);
                //console.log("IMAGE", image);
                let width = 512;        // Random Value
                let height = 512;       // Random Value
                //ImageReact.getSize(image, (width, height));
                newImagesUrls.push(
                    [{ 
                        index: 0, mode: "BACKGROUND", category: "background_userUpload", name: "User Background",  
                        src: src, 
                        width: width, height: height, x:0, y:0
                    }]
                )
            }
        );
        setEditorBackgroudList(editorBackgroudList.concat(newImagesUrls));
        setAvailableBackground(availableBackground.concat(newImagesUrls));

    }, [uploadBackground]);

    const [uploadAsset, setUploadAsset] = useState([]);
    function onUploadAssetImageChange(e) {
        setUploadAsset([...e.target.files]);
    }

    useEffect(() => {
        if (uploadAsset.length <1) {
            return;
        }
        let newImagesUrls = [];
        // We currently only loop this once since we only allow one
        // Image to be uploaded at a time from the UI
        newImagesUrls = [];
        uploadAsset.forEach(image =>  {
            const src = URL.createObjectURL(image);
            //console.log("IMAGE", image);
            let width = 128;        // Random Value
            let height = 128;       // Random Value
            //ImageReact.getSize(image, (width, height));
            newImagesUrls.push(
                {   
                    index: 0, 
                    type: "CUSTOM_ASSET",
                    id: 'customAsset_' + availableAssets.length,
                    image_local_file_transparent: src, 
                    name: "User Asset",
                    scale: 1,               // -1 to flip the element
                    addedToCanvas: false,    // Allow to only add the cow once to the canvas
                    width: width, height: height, x:0, y:0
                }
            )
        });
        //console.log(availableAssets);
        setAvailableAssets(availableAssets.concat(newImagesUrls));
        
    }, [uploadAsset]);
    
    // Create a reference to the hidden file input element
    const hiddenUploadBackgroundFileInput = React.useRef(null);
    const hiddenUploadAssetFileInput = React.useRef(null);

    // Programatically click the hidden file input element
    // when the Button component is clicked
    const handleUploadBackgroundButtonClick = event => {
        hiddenUploadBackgroundFileInput.current.click();
    };

    // Programatically click the hidden file input element
    // when the Button component is clicked
    const handleUploadAssetButtonClick = event => {
        hiddenUploadAssetFileInput.current.click();
    };



    // FUNCTION FOR CARD GENERATOR

    function getScaledImageCoordinates(
        containerWidth,
        containerHeight,
        width,
        height,
        returnWidth
    ) {
        var widthRatio = (containerWidth) / width,
            heightRatio = (containerHeight) / height
        var bestRatio = Math.min(widthRatio, heightRatio)
        var newWidth = width * bestRatio,
            newHeight = height * bestRatio
        console.log("Return width=" + newWidth + " - height=" + newHeight);

        if (returnWidth === true) {
            return newWidth;
        } else {
            return newHeight;
        }

    }

    










    const styles = reactCSS({
      'default': {
        cardBorderStartColor: {
          width: '36px',
          height: '14px',
          borderRadius: '2px',
          background: `rgba(${ cardBorderStartColor.r }, ${ cardBorderStartColor.g }, ${ cardBorderStartColor.b }, ${ cardBorderStartColor.a })`,
        },
        cardBorderEndColor: {
            width: '36px',
            height: '14px',
            borderRadius: '2px',
            background: `rgba(${ cardBorderEndColor.r }, ${ cardBorderEndColor.g }, ${ cardBorderEndColor.b }, ${ cardBorderEndColor.a })`,
          },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });














return (

    <>

    <Container fluid h-100 className="cardGeneratorTopContainer">

        {/* For any application level message we want to display to the user
        <ToastContainer 
            type="error"
            position="top-center"/> */}
    
        {/* <Container className="pt-2 d-block d-lg-none" fluid>
            <div className="alert alert-dark">Welcome to the GMCafé Meme Creator.</div>
        </Container> */}

       
        <Row className="h-100 pt-2">
        
            {/* ASSET SELECTOR LEFT HAND SIDE */}
            <Col className="col-md-12 col-lg-4 col-xl-3 col-xxl-3">
                <Container className="">
                    <Card className="mb-2 menuContainer">
                        <Card.Header 
                                className="accordionHeader text-left"
                                onClick={() => setToggleUICowSelector(toggleUICowSelector => !toggleUICowSelector)}
                                aria-controls="collapseUICowSelector"
                                aria-expanded={toggleUICowSelector}>{props.labelsConfig.availableItems}
                                <ArrowsCollapse className="float-right"/>
                        </Card.Header>
                        <Collapse in={toggleUICowSelector}>
                            <div className="collapse" id="collapseUICowSelector">

                                <Accordion flish="true" defaultActiveKey={accordionDefaultActiveKey} flush>
            
                                        { ( allowCheckUserWallet ) && (

                                        <Card>
                                            <Card.Header className="moduleHeader">
                                            <GenericBootstrapAccordionToggle eventKey="10">{props.labelsConfig.myAssetTitlePannel}</GenericBootstrapAccordionToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="10">
                                            <Card.Body className="moduleContent">

                                            {(myCows.length >0) ? (

                                                <div className="row">
                                                {myCows.map(d => (
                                                    <>
                                                    <Col className="col">
                                                        <img
                                                            className="mt-2"
                                                            alt={d.name}
                                                            src={d.image_local_file_thumbnail}
                                                            height={74}
                                                            draggable={d.image_local_file_thumbnail === d.image_local_file_transparent}
                                                            onClick={(e) => {
                                                                if (!d.addedToCanvas) {
                                                                    addAssetToCanvas(e, d, true, d.image_local_file_transparent, false);
                                                                }
                                                            }}
                                                            onDragStart={(e) => {
                                                                dragUrl.current = e.target.src;
                                                                dragUrlId.current = d.index;
                                                                dragUrlHeight.current = e.target.height;
                                                                dragUrlWidth.current = e.target.width;
                                                            }} 
                                                            title={d.name}
                                                        />
                                                        
                                                        { (props.displayItemLegendConfig.assets === true) && 
                                                            <span className="row justify-content-center BGAssetLegend">{d.name}</span> 
                                                        }
                                                        
                                                    </Col>
                                                    </>                                           
                                                ))}

                                                </div>

                                            ):(

                                                <>

                                                { (wallet.status !== 'connected') ? (

                                                    <>
                                                    <Row>
                                                        Connect your wallet to get direct access to the {props.labelsConfig.assetName}(s) you own.  
                                                    </Row>
                                                    <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">

                                                        <WalletConnectionButtons/>
                                                        
                                                    </Row>
                                                    </>

                                                ) : (

                                                    <>                                      
                                                    <Row>
                                                        Unfortunately we can't find any {props.labelsConfig.assetName}(s) in the wallet you connected...
                                                    </Row>
                                                    <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">
                                                        <Button title="Disconnect wallet" 
                                                                className="btn-success menu-icon"
                                                                onClick={() => walletDisconnect('reset')}>
                                                            <Wallet2 /> Disconnect Wallet
                                                        </Button>
                                                    </Row>
                                                    </>

                                                )}

                                                </>

                                            )}

                                            <Row className="d-flex justify-content-center align-items-center align-self-center mt-2">Wallet to lookup: </Row>
                                            <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                <div class="input-group">
                                                    <input type="text" 
                                                            class="form-control" 
                                                            placeholder="Or provide a wallet to lookup here..." 
                                                            value={ownerWalletAddress || ""}
                                                            onChange={evt => setOwnerWalletAddress(evt.target.value)}></input>
                                                </div>
                                            </Row>

                                            </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>

                                        )}

                                        <Card>
                                            <Card.Header className="moduleHeader">
                                            <GenericBootstrapAccordionToggle eventKey="11">{props.labelsConfig.allAssetTitlePannel}</GenericBootstrapAccordionToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="11">
                                            <Card.Body className="moduleContent">

                                                <PaginatedItems 
                                                    itemsPerPage={8} 
                                                    data={availableCows} 
                                                    config={props}
                                                    addAssetToCanvasFunction={addAssetToCanvas}
                                                />

                                                <Container className="text-center">
                                                    
                                                    { ((allowAssetSelection) &&

                                                        <>
                                                            <Row className="mt-2 mb-2 d-flex justify-content-center align-items-center align-self-center">
                                                                <div>{props.labelsConfig.assetSearchLabelText}</div>
                                                            </Row>
                                                            <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                                Trait search:&nbsp;<input 
                                                                type="text"
                                                                style={{width: "130px"}} 
                                                                value={searchQueryAssetCollection || ""}
                                                                onChange={evt => updateInputValueForCollectionSelector(evt)}></input><Button title="Perform Search" className="mt-2 ml-2 btn-success menu-icon" onClick={performSearchQueryAssetCollection}>
                                                                <PlusCircle/> {props.labelsConfig.assetSearchButtonText}</Button>
                                                            </Row>
                                                        </>
                                                    )}

                                                    { ((allowAssetReRollConfig.collection) &&

                                                        <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                            <Button title="Let's Roll The Dice" className="mt-2 ml-2 btn-success menu-icon" onClick={() => reRollAssetCollection("collection")}>
                                                                <Dice5/> Randomise
                                                            </Button>
                                                        </Row>
                                                    
                                                    )}

                                                </Container>

                                            </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>


                                        { ( canDisplayPartner1Panel ) && (

                                            <Card>
                                                <Card.Header className="moduleHeader">
                                                <GenericBootstrapAccordionToggle eventKey="12">{props.labelsConfig.partner1TitlePannel}</GenericBootstrapAccordionToggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey="12">
                                                <Card.Body className="moduleContent">

                                                <PaginatedItems 
                                                    itemsPerPage={8} 
                                                    data={allPartnerAssets[0]} 
                                                    config={props}
                                                    addAssetToCanvasFunction={addAssetToCanvas}
                                                />

                                                <Container className="text-center">
                                                    
                                                    { ((allowAssetSelection) &&
                                                        <>
                                                            <Row className="mt-2 mb-2 d-flex justify-content-center align-items-center align-self-center">
                                                                <div>{props.labelsConfig.partner1AssetSearchLabelText}</div>
                                                            </Row>
                                                            <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                                Trait search:&nbsp;<input 
                                                                type="text"
                                                                style={{width: "130px"}} 
                                                                value={searchQueryPartner1Collection || ""}
                                                                onChange={evt => updateInputValueForPartner1Selector(evt)}></input><Button title="Perform Search" className="mt-2 ml-2 btn-success menu-icon" onClick={performSearchQueryPartner1Collection}>
                                                                <PlusCircle/> {props.labelsConfig.partner1AssetSearchButtonText}</Button>
                                                            </Row>
                                                        </>
                                                    )}

                                                    { ((allowAssetReRollConfig.partner1) &&

                                                        <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                            {/* <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                                Want to generate a different set of assets for this partner's collection? 
                                                            </Row> */}
                                                            <Button title="Let's Roll The Dice" className="mt-2 ml-2 btn-success menu-icon" onClick={() => reRollAssetCollection("partner1")}>
                                                                <Dice5/> Randomise
                                                            </Button>
                                                        </Row>
                                                    
                                                    )}

                                                </Container>

                                                </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                        )}

                                        { ( canDisplayPartner2Panel ) && (

                                            <Card>
                                                <Card.Header className="moduleHeader">
                                                <GenericBootstrapAccordionToggle eventKey="13">{props.labelsConfig.partner2TitlePannel}</GenericBootstrapAccordionToggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey="13">
                                                <Card.Body className="moduleContent">

                                                <PaginatedItems 
                                                    itemsPerPage={8} 
                                                    data={allPartnerAssets[1]} 
                                                    config={props}
                                                    addAssetToCanvasFunction={addAssetToCanvas}
                                                />

                                                <Container className="text-center">
                                                    
                                                    { ((allowAssetSelection) &&
                                                        <>
                                                            <Row className="mt-2 mb-2 d-flex justify-content-center align-items-center align-self-center">
                                                                <div>{props.labelsConfig.partner1AssetSearchLabelText}</div>
                                                            </Row>
                                                            <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                                Trait search:&nbsp;<input 
                                                                type="text"
                                                                style={{width: "130px"}} 
                                                                value={searchQueryPartner1Collection || ""}
                                                                onChange={evt => updateInputValueForPartner2Selector(evt)}></input><Button title="Perform Search" className="mt-2 ml-2 btn-success menu-icon" onClick={performSearchQueryPartner2Collection}>
                                                                <PlusCircle/> {props.labelsConfig.partner2AssetSearchButtonText}</Button>
                                                            </Row>
                                                        </>
                                                    )}

                                                    { ((allowAssetReRollConfig.partner2) &&

                                                        <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                            {/* <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                                Want to generate a different set of assets for this partner's collection? 
                                                            </Row> */}
                                                            <Button title="Let's Roll The Dice" className="mt-2 ml-2 btn-success menu-icon" onClick={() => reRollAssetCollection("partner2")}>
                                                                <Dice5/> Randomise
                                                            </Button>
                                                        </Row>
                                                    
                                                    )}

                                                </Container>

                                                </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                        )}


                                        {/* { ( canDisplayAccessories1Panel ? (

                                                <Card>
                                                    <Card.Header className="moduleHeader d-flex justify-content-start">
                                                    <GenericBootstrapAccordionToggle eventKey="14">{props.labelsConfig.accessories1TitlePannel}</GenericBootstrapAccordionToggle>
                                                    </Card.Header>
                                                    <Accordion.Collapse eventKey="14">
                                                    <Card.Body className="moduleContent">
                                                        
                                                        <Carousel  
                                                            autoPlay={false}
                                                            controls={true} 
                                                            prevLabel={null} nextLabel={null} 
                                                            indicators={false}
                                                            interval={null}
                                                            nextIcon={<ChevronRight color="black" />}
                                                            prevIcon={<ChevronLeft color="black" />}>
                                                            { availableAccessories1Slices.map((row, index) => ( 
                                                                <Carousel.Item >
                                                                    <div className="row pl-3 pr-3 mb-2 mr-1 ml-1">
                                                                        {row.map(d => (
                                                                            <>
                                                                            <Col className="col">
                                                                                <img
                                                                                    className=""
                                                                                    alt={d.name}
                                                                                    src={d.image_local_file_transparent}
                                                                                    width={74}
                                                                                    draggable={d.image_local_file_thumbnail === d.image_local_file_transparent}
                                                                                    onClick={(e) => {
                                                                                        if (!d.addedToCanvas) {
                                                                                            addAssetToCanvas(e, d.index, true);
                                                                                        }
                                                                                    }}
                                                                                    onDragStart={(e) => {
                                                                                        dragUrl.current = e.target.src;
                                                                                        dragUrlId.current = d.index;
                                                                                        dragUrlHeight.current = e.target.height;
                                                                                        dragUrlWidth.current = e.target.width;
                                                                                    }} 
                                                                                    title={d.name}
                                                                                />
                                                                                { (props.displayItemLegendConfig.accessories1 === true) && 
                                                                                    <span className="row justify-content-center BGAssetLegend">{d.name}</span> 
                                                                                }
                                                                            </Col>
                                                                            </>                                           
                                                                        ))}
                                                                    </div>
                                                                    <Carousel.Caption bsPrefix={"carousel-caption-custom"} >
                                                                        <p>Page {index+1}/{availableAccessories1Slices.length} (Total: {availableAccessories1.length})</p>
                                                                    </Carousel.Caption>
                                                                </Carousel.Item>
                                                                ))
                                                            }
                                                        </Carousel>
                                                    
                                                    </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>

                                        ) : (

                                            <>

                                            { ( accessories1PannelWalletRequired && (

                                                <Card>
                                                    <Card.Header className="moduleHeader d-flex justify-content-start">
                                                    <GenericBootstrapAccordionToggle eventKey="15">{props.labelsConfig.accessories1TitlePannel}</GenericBootstrapAccordionToggle>
                                                    </Card.Header>
                                                    <Accordion.Collapse eventKey="15">
                                                    <Card.Body className="moduleContent">
                                                        {(wallet.status !== 'connected') ? (
                                                            <>
                                                            <Row>{props.labelsConfig.accessories1MessageToConnectWallet}</Row>
                                                            <WalletConnectionButtons/>
                                                            </>
                                                        ): (
                                                            <>
                                                            <Row>{props.labelsConfig.accessories1MessageNoNFTFoundInWallet}</Row>
                                                            <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">
                                                                <Button title="Disconnect Wallet" 
                                                                        className="btn-success menu-icon"
                                                                        onClick={() => walletDisconnect('reset')}>
                                                                    <Wallet2 /> Disconnect Wallet
                                                                </Button>
                                                            </Row>
                                                            </>
                                                        )}
                                                    
                                                    </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>

                                            )) }

                                            </>

                                        ))}

                                        { ( canDisplayAccessories2Panel ? (

                                        <Card>
                                            <Card.Header className="moduleHeader d-flex justify-content-start">
                                            <GenericBootstrapAccordionToggle eventKey="16">{props.labelsConfig.accessories2TitlePannel}</GenericBootstrapAccordionToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="16">
                                            <Card.Body className="moduleContent">
                                                
                                                <Carousel  
                                                        autoPlay={false}
                                                        controls={true} 
                                                        prevLabel={null} nextLabel={null} 
                                                        indicators={false}
                                                        interval={null}
                                                        nextIcon={<ChevronRight color="black" />}
                                                        prevIcon={<ChevronLeft color="black" />}>
                                                        { availableAccessories2Slices.map((row, index) => ( 
                                                            <Carousel.Item >
                                                                <div className="row pl-3 pr-3 mb-2 mr-1 ml-1">
                                                                    {row.map(d => (
                                                                        <>
                                                                        <Col className="col">
                                                                            <img
                                                                                className=""
                                                                                alt={d.name}
                                                                                src={d.image_local_file_transparent}
                                                                                width={74}
                                                                                draggable={d.image_local_file_thumbnail === d.image_local_file_transparent}
                                                                                onClick={(e) => {
                                                                                    if (!d.addedToCanvas) {
                                                                                        addAssetToCanvas(e, d.index, true);
                                                                                    }
                                                                                }}
                                                                                onDragStart={(e) => {
                                                                                    dragUrl.current = e.target.src;
                                                                                    dragUrlId.current = d.index;
                                                                                    dragUrlHeight.current = e.target.height;
                                                                                    dragUrlWidth.current = e.target.width;
                                                                                }} 
                                                                                title={d.name}
                                                                            />
                                                                            { (props.displayItemLegendConfig.accessories2 === true) && 
                                                                                <span className="row justify-content-center BGAssetLegend">{d.name}</span> 
                                                                            }
                                                                        </Col>
                                                                        </>                                           
                                                                    ))}
                                                                </div>
                                                                <Carousel.Caption bsPrefix={"carousel-caption-custom"} >
                                                                    <p>Page {index+1}/{availableAccessories2Slices.length} (Total: {availableAccessories2.length})</p>
                                                                </Carousel.Caption>
                                                            </Carousel.Item>
                                                            ))
                                                        }
                                                    </Carousel>
                                            
                                            </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>

                                        ) : (

                                            <>

                                            { ( accessories2PannelWalletRequired && (

                                            <Card>
                                                <Card.Header className="moduleHeader d-flex justify-content-start">
                                                <GenericBootstrapAccordionToggle eventKey="15">{props.labelsConfig.accessories2TitlePannel}</GenericBootstrapAccordionToggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey="15">
                                                <Card.Body className="moduleContent">
                                                    {(wallet.status !== 'connected') ? (
                                                        <>
                                                        <Row>{props.labelsConfig.accessories2MessageToConnectWallet}</Row>
                                                        <WalletConnectionButtons/>
                                                        </>
                                                    ): (
                                                        <>
                                                        <Row>{props.labelsConfig.accessories2MessageNoNFTFoundInWallet}</Row>
                                                        <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">
                                                            <Button title="Disconnect Wallet" 
                                                                    className="btn-success menu-icon"
                                                                    onClick={() => walletDisconnect('reset')}>
                                                                <Wallet2 /> Disconnect Wallet
                                                            </Button>
                                                        </Row>
                                                        </>
                                                    )}
                                                
                                                </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                            )) }

                                            </>

                                        ))} */}

                                        { props.allowAssetUploadAsAssets && (

                                        <Card>
                                            <Card.Header className="moduleHeader d-flex justify-content-start">
                                                <GenericBootstrapAccordionToggle eventKey="17">{props.labelsConfig.yourUploadedAsset}</GenericBootstrapAccordionToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="17">
                                            <Card.Body className="moduleContent">
                                                <div className="row justify-content-center">

                                                    {availableAssets.map(d => (
                                                        <>
                                                        <Col className="col">
                                                            <img
                                                                className="mt-2"
                                                                alt={d.name}
                                                                src={d.image_local_file_transparent}
                                                                height={74}
                                                                draggable={d.image_local_file_thumbnail === d.image_local_file_transparent}
                                                                onClick={(e) => {
                                                                    if (!d.addedToCanvas) {
                                                                        addAssetToCanvas(e, d, true, null, true);
                                                                    }
                                                                }}
                                                                onDragStart={(e) => {
                                                                    dragUrl.current = e.target.src;
                                                                    dragUrlId.current = d.index;
                                                                    dragUrlHeight.current = e.target.height;
                                                                    dragUrlWidth.current = e.target.width;
                                                                }} 
                                                                title={d.name}
                                                            />
                                                            { (props.displayItemLegendConfig.uploads === true) && 
                                                                <span className="row justify-content-center BGAssetLegend">{d.name}</span>
                                                            }
                                                        </Col>
                                                        </>                                           
                                                    ))}

                                                    <Container className="text-center">
                                                        <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">
                                                            Select an asset you would like to upload
                                                        </Row>
                                                        <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">
                                                                <input 
                                                                    value="" 
                                                                    id="fileUpload"
                                                                    ref={hiddenUploadAssetFileInput} 
                                                                    name="file" type="file" single="true" accept="image/*" 
                                                                    style={{ display: "none" }} 
                                                                    onChange={onUploadAssetImageChange}/>
                                                                <label htmlFor="fileUpload">
                                                                    <Button title="Upload Your Own Asset" 
                                                                            className="btn-success menu-icon"
                                                                            onClick={handleUploadAssetButtonClick}>
                                                                        <Upload /> Upload asset
                                                                    </Button>
                                                                </label>
                                                        </Row>
                                                    </Container>
                                                </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card> 
                                        
                                        )}

                                    </Accordion>

                                    

                                        
                                    {/* </Card.Text>
                                </Card.Body> */}
                            </div>
                        </Collapse>
                    </Card>
                    
                </Container>

            </Col>
            
            {/* MAIN CANVAS */}
            <Col className="col-md-12 col-lg-4 col-xl-6 col-xxl-6">

                {/* MAIN CANVAS - BACKGROUND GENERATOR */}
                <Container className="">

                        <Container className="mb-4">
                            <div className="bg-toolbar d-flex justify-content-center align-items-stretch text-center">
                                
                                <Row className="justify-content-center text-center">
        
                                    <Col className="d-xl-flex justify-content-center">
                                        <Button title="Instructions On How To Use This Tool" className="mt-1 btn-success secondary-icon" onClick={handleInstructionsModalShow}>
                                            <Book /> Instructions
                                        </Button>
                                        
                                        <Button title="Download Your Creation" className="mt-1 ml-2 btn-success secondary-icon" onClick={handleImageExport}>
                                            <Download /> Download
                                        </Button>
                                        
                                    </Col>

                                </Row>
                            </div>
                        </Container>

                        <Container className="" id="stageContainer">

                            <div className="d-flex justify-content-center align-items-center text-center">

                                <Stage
                                    className="align-items-center"
                                    ref={stageRef}
                                    width={300} height={420}
                                    // style={{ border: '2px solid black' }}
                                >

                                    <Layer>
                        
                                            {/* CARD FRAME  */}
                                            <Rect
                                                key={"Card_Border"}
                                                ref={uiCardBackgroundBorder}
                                                x={0} y={0}
                                                height={420} width={300}
                                                // strokeWidth={2} // border width
                                                // stroke="black" // border color
                                                fillLinearGradientStartPoint={{ x: 0, y: 105 }}
                                                fillLinearGradientEndPoint={{ x: 0, y: 420 }}
                                                fillLinearGradientColorStops={[
                                                    0, "rgb(" + cardBorderStartColor.r + ", " + cardBorderStartColor.g + ", " + cardBorderStartColor.b + ")", 
                                                    1, "rgb(" + cardBorderEndColor.r + ", " + cardBorderEndColor.g + ", " + cardBorderEndColor.b + ")", 
                                                ]}
                                                cornerRadius={[20, 20, 20, 20]}
                                            />

                                            { ( !isPFPOnCanvasUploaded ? (

                                                <>
                                                {/* PFP EXTRA BORDER (USING PFP BACKGROUND COLOR) AT TOP OF CARD   */}
                                                    <Rect
                                                    key={"Card_PFPBorder"}
                                                    ref={uiCardPFPBorder}
                                                    x={10} y={10}
                                                    height={20} width={280}
                                                    cornerRadius={[20, 20, 0, 0]}
                                                    fill={ "rgb(" + pfpBackgroundColor.r + ", " + pfpBackgroundColor.g + ", " + pfpBackgroundColor.b + ")" }
                                                    // DEBUG fill="yellow"
                                                    
                                                />
                                                <Rect
                                                    key={"Card_PFPBorderTop"}
                                                    x={10} y={30}
                                                    height={30} width={300 - 20}
                                                    fill={ "rgb(" + pfpBackgroundColor.r + ", " + pfpBackgroundColor.g + ", " + pfpBackgroundColor.b + ")" }
                                                    //DEBUG fill="yellow"  
                                                />
                                                <Rect
                                                    key={"Card_PFPBorderLeft"}
                                                    x={10} y={30}
                                                    height={284} width={20}
                                                    fill={ "rgb(" + pfpBackgroundColor.r + ", " + pfpBackgroundColor.g + ", " + pfpBackgroundColor.b + ")" }
                                                    //DEBUG fill="yellow"  
                                                />
                                                <Rect
                                                    key={"Card_PFPBorderRight"}
                                                    x={270} y={30}
                                                    height={284} width={20}
                                                    fill={ "rgb(" + pfpBackgroundColor.r + ", " + pfpBackgroundColor.g + ", " + pfpBackgroundColor.b + ")" }
                                                    //DEBUG fill="yellow"  
                                                />
                                                {/* <Rect
                                                    key={"Card_PFPBordeBottom"}
                                                    x={10} y={280}
                                                    height={20} width={280}
                                                    fill={ "rgb(" + pfpBackgroundColor.r + ", " + pfpBackgroundColor.g + ", " + pfpBackgroundColor.b + ")" }
                                                    //DEBUG fill="yellow"  
                                                /> */}
                                                

                                                {/* PFP Frame with clipping for icon at the bottom */}
                                                <Shape
                                                    sceneFunc={(context, shape) => {
                                                        
                                                        context.save();
                                                        context.beginPath();

                                                        context.strokeStyle = "red"; // Set the border color to red
                                                        context.lineWidth = 2; // Set the border width
                                                        
                                                        context.lineTo(0, 0);                           // Starting point 
                                                        context.lineTo(0, 314);                         // Line from top left to bottom left 
                                                        context.lineTo(120, 314);                       // Start line from bottom left                                                 
                                                        //context.moveTo(120,314);
                                                        context.arc(149, 314, 30, Math.PI, 0, 0);       // arc circle 
                                                        context.lineTo(420, 314);                       // End line to bottom right 
                                                        context.lineTo(420, 0);                         // Line from bottom righ to top right 
                                                        context.closePath();                            // Going back to starting point 
                                                        context.clip();
                                                        
                                                        // Need to make sure the image is defined before drawing it 
                                                        if (cardPfpImage) {
                                                            //context.cornerRadius([20, 20, 0, 0]);
                                                            //context.drawImage(cardPfpImage, 10, 30, 280, 280);    // Old version cutting off tops 
                                                            context.drawImage(cardPfpImage, 25, 60, 254, 254);
                                                        }

                                                        context.fillStrokeShape(shape);
                                                        
                                                    }}

                                                />
                                                </>
                                            


                                            ) : (

                                                <>
                                                    
                                                    {/* PFP Frame with clipping for icon at the bottom */}
                                                    <Shape
                                                        sceneFunc={(context, shape) => {
                                                            
                                                            context.save();
                                                            context.beginPath();
                                                            
                                                            context.lineTo(0, 0);                           // Starting point 
                                                            context.lineTo(0, 314);                         // Line from top left to bottom left 
                                                            context.lineTo(120, 314);                       // Start line from bottom left                                                 
                                                            //context.moveTo(120,314);
                                                            context.arc(149, 314, 30, Math.PI, 0, 0);       // arc circle 
                                                            context.lineTo(420, 314);                       // End line to bottom right 
                                                            context.lineTo(420, 0);                         // Line from bottom righ to top right 
                                                            context.closePath();                            // Going back to starting point 
                                                            context.clip();
                                                            
                                                            // Need to make sure the image is defined before drawing it 
                                                            if (cardPfpImage) {
                                                                context.drawImage(cardPfpImage, userUploadPFPPosX, userUploadPFPPosY, userUploadPFPWidth, userUploadPFPHeight);
                                                                //context.drawImage(cardPfpImage, 10, 15, 280, 280);
                                                            }

                                                            context.fillStrokeShape(shape);
                                                            
                                                        }}
                                                        
                                                    />

                                                {/* PFP EXTRA BORDER (USING PFP BACKGROUND COLOR) AT TOP OF CARD  
                                                <Rect
                                                    key={"Card_PFPBorder"}
                                                    ref={uiCardPFPBorder}
                                                    x={10} y={10}
                                                    height={20} width={300 - 20}
                                                    cornerRadius={[20, 20, 0, 0]}
                                                    fill={ "rgb(" + pfpBackgroundColor.r + ", " + pfpBackgroundColor.g + ", " + pfpBackgroundColor.b + ")" }
                                                    // DEBUG fill="yellow"
                                                    
                                                />
                                                */}
                                                    
                                                </>

                                            ))}

                                            {/* SCROLL IMAGE */}
                                            <ImageKonva 
                                                key={"Card_ScrollImage"}
                                                ref={uiCardScroll}
                                                image={ cardScrollElement } 
                                                x={20} y={20}
                                                width={262} height={50}
                                            />
                                            
                                            {/* SCROLL TEXT */}
                                            <Text
                                                key={"Card_Header"}
                                                ref={uiCardBackgroundHeader}
                                                text={cardTextTitle}
                                                fontFamily={"CardTitleFont"}
                                                fontWeight={"normal"}
                                                align={"center"}
                                                x={35} y={29}
                                                width={228} height={12}
                                                fontSize={22}
                                            />

                                            {/* CARD ICON IMAGE */}
                                            <ImageKonva 
                                                key={"Card_IconImage"}
                                                ref={uiCardIcon}
                                                image={ cardIconImage } 
                                                x={127} y={289}
                                                width={45} height={45}
                                                
                                            />

                                            {/* CARD NAME TEXT */}
                                            <ImageKonva 
                                                key={"Card_TextOne"}
                                                ref={uiCardTextOne}
                                                image={ cardRenderedTextCardName } 
                                                x={21} y={334}
                                                // fillEnabled={false}
                                                //width={260} height={17}
                                                scaleX={1 / window.devicePixelRatio}
                                                scaleY={1 / window.devicePixelRatio}
                                                // draggable={true}
                                            />

                                            {/* CARD ABILITY TEXT */}
                                            <ImageKonva 
                                                key={"Card_TextTwo"}
                                                ref={uiCardTextTwo}
                                                image={ cardRenderedTextCardText } 
                                                x={21} y={352}
                                                // width={260} 
                                                //height={26} 
                                                scaleX={1 / window.devicePixelRatio}
                                                scaleY={1 / window.devicePixelRatio}
                                            />

                                            {/* CARD DETAILS TEXT */}
                                            <Text
                                                ref={uiCardTextThree}
                                                key={"Card_TextThree"}
                                                text={cardTextDetails}
                                                fontFamily={"CardSignatureFont"}
                                                fontWeight={"italic"}
                                                fill={"white"}
                                                align={"center"}
                                                x={21} y={389}
                                                width={260} height={15}
                                                // padding={0,0,10,10}
                                                fontSize={7}
                                            />

                                    </Layer>

                                </Stage>
                                
                                </div>

                                {/* Element for rich text elements */}
                                <div className="card-name-rendered-container">{renderCardNameText(cardNameRawText)}</div>
                                <div className="card-text-rendered-container">{renderCardTextText(cardTextRawText)}</div>

                        </Container>

                </Container>

            </Col>

            {/* CARD GENERATOR SELECTOR RIGHT HAND SIDE  */}
            <Col className="col-md-12 col-lg-4 col-xl-3 col-xxl-3">
                <Container className="mt-3">

                    <Card className="mb-2 menuContainer">
                        <Card.Header 
                                className="accordionHeader text-left"
                                onClick={() => setToggleUIBackgroundSelector(toggleUIBackgroundSelector => !toggleUIBackgroundSelector)}
                                aria-controls="collapseUIBackgroundSelector"
                                aria-expanded={toggleUIBackgroundSelector}>{props.labelsConfig.availableBackgrounds}<ArrowsCollapse className="float-right"/></Card.Header>
                        <Collapse in={toggleUIBackgroundSelector}>

                            <div className="collapse" id="collapseUIInstructions">
                                    <Accordion flish="true" defaultActiveKey="20" flush>

                                        {/* FORM DETAILS FOR CARD GENERATOR PROPERTIES */}
                                        <Card>
                                            <Card.Header className="moduleHeader">
                                            <GenericBootstrapAccordionToggle eventKey="20">{props.labelsConfig.myCardGeneratorFormTitlePannel}</GenericBootstrapAccordionToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="20">
                                            <Card.Body className="moduleContent">

                                                <div className="row">
                                                
                                                <Col className="col">
                                                    
                                                    <Form>

                                                        <Form.Group className="mb-3" controlId="formCardName">

                                                            <Form.Label>Border Colors</Form.Label>
                                                            <div>

                                                                Start color: 
                                                                
                                                                {/* USING CUSTOM REACT-COLOR PICKER  */}
                                                                {/* <div style={ styles.swatch } onClick={ () => handleBorderColorPickerClick("startColor") }>
                                                                <div style={ styles.cardBorderStartColor } />
                                                                </div>
                                                                { displayBorderStartColorPicker ? <div style={ styles.popover }>
                                                                <div style={ styles.cover } onClick={ () => handleBorderColorPickerClose("startColor") }/>
                                                                <SketchPicker color={ cardBorderStartColor } onChange={ (color) => handleBorderColorPickerChange(color, "startColor") } />
                                                                </div> : null } */}

                                                                {/* USING NATIVE COLOR PICKER WITH EYE DROPPER */}
                                                                &nbsp;<input type="color" value={rgbToHex(cardBorderStartColor.r, cardBorderStartColor.g, cardBorderStartColor.b)} onChange={e => handleBorderColorPickerChangeFromRGB(e.target.value, "startColor")} />

                                                            

                                                                &nbsp;| End color: 
                                                                
                                                                {/* USING CUSTOM REACT-COLOR PICKER  */}
                                                                {/* <div style={ styles.swatch } onClick={ () => handleBorderColorPickerClick("endColor") }>
                                                                <div style={ styles.cardBorderEndColor } />
                                                                </div>
                                                                { displayBorderEndColorPicker ? <div style={ styles.popover }>
                                                                <div style={ styles.cover } onClick={ () => handleBorderColorPickerClose("endColor") }/>
                                                                <SketchPicker color={ cardBorderEndColor } onChange={ (color) => handleBorderColorPickerChange(color, "endColor") } />
                                                                </div> : null } */}

                                                                {/* USING NATIVE COLOR PICKER WITH EYE DROPPER */}
                                                                &nbsp;<input type="color" value={rgbToHex(cardBorderEndColor.r, cardBorderEndColor.g, cardBorderEndColor.b)} onChange={e => handleBorderColorPickerChangeFromRGB(e.target.value, "endColor")} />

                                                            </div>
                                                            <Form.Text className="text-muted">
                                                                    The start and end colors for the card's border
                                                            </Form.Text>

                                                        </Form.Group>

                                                        <Form.Group className="mb-3" controlId="formCardName">
                                                            <Form.Label>Card title</Form.Label>
                                                            {/* Max character allowed: 23 */}
                                                            <Form.Control type="text" maxLength={25} value={cardTextTitle} onChange={evt => updateInputValueForCardProperties(evt.target.value, 'cardTextTitle', false)} />
                                                            <Form.Text className="text-muted">
                                                            This is the title for the card
                                                            </Form.Text>
                                                        </Form.Group>
                                                        
                                                        <Alert variant="secondary" className="p-2 card-details-form-text">
                                                            <p className="m-0">To style your text in Card Name or Ability use **text** to make it bold 
                                                            and use __text__ to make it italic.
                                                            <br/><br/>
                                                            Example: Entering **Hello** will display as <span style={{ fontWeight: 'bold' }}>Hello</span>. 
                                                            Entering __World__ will display as <span style={{ fontStyle: 'italic' }}>World</span>.</p>
                                                        </Alert>

                                                        <Form.Group className="mb-3" controlId="formCardName">
                                                            <Form.Label>Card name</Form.Label>
                                                            <Dropdown title="Change Template Color" className="cardname mt-1 ml-2">
                                                            <Dropdown.Toggle variant="btn-success tertiary-icon" id="dropdown-basic">
                                                                Choose a card
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {cardTextCardNameSelect.map((option, index) => (
                                                                    <Dropdown.Item key={`CardNameDropdown` + index} onClick={ (e) => {updateInputValueForCardProperties(option.value, 'cardTextCardName', false)}}>{option.text}</Dropdown.Item>
                                                                ))}
                                                            </Dropdown.Menu>
                                                            </Dropdown>
                                                            {/* Max character allowed: 35 */}
                                                            <Form.Control type="text" maxLength={35} value={cardTextName} onChange={evt => updateInputValueForCardProperties(evt.target.value, 'cardTextCardName', true)} />
                                                            <Form.Text className="text-muted">
                                                            This is the name for the card
                                                            </Form.Text>
                                                        </Form.Group>

                                                        <Form.Group className="mb-3" controlId="formCardName">
                                                            <Form.Label>Card ability</Form.Label>
                                                            {/* Max character allowed: 126 + adding 5*2 = 10 to support bolding items  */}
                                                            <Form.Control type="text" maxLength={225} value={cardTextCardEffect} onChange={evt => updateInputValueForCardProperties(evt.target.value, 'cardTextCardEffect', false)} />
                                                            <Form.Text className="text-muted">
                                                            This is the ability of the card
                                                            </Form.Text>
                                                        </Form.Group>
                                                        <Form.Group className="mb-3" controlId="formCardName">
                                                            <Form.Label>Card flavor</Form.Label>
                                                            {/* Max character allowed: 100 */}
                                                            <Form.Control type="text" maxLength={225} value={cardTextDetails} onChange={evt => updateInputValueForCardProperties(evt.target.value, 'cardTextDetails', false)} />
                                                            <Form.Text className="text-muted">
                                                            This is for the flavor of the card
                                                            </Form.Text>
                                                        </Form.Group>

                                                        {/* <Button variant="primary" type="submit">
                                                            Update the card design
                                                        </Button> */}
                                                    </Form>
                                                    
                                                </Col>

                                            </div>

                                            </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>

                                        { (isPFPOnCanvasUploaded && !isPFPLegendSelected) && ( 

                                            <>
                                            {/* UPLOAD IMAGE POSITION CONTROLS */}
                                            <Card>
                                                <Card.Header className="moduleHeader">
                                                <GenericBootstrapAccordionToggle eventKey="21">{props.labelsConfig.myCardGeneratorResizeControlTitlePannel}</GenericBootstrapAccordionToggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey="21">
                                                <Card.Body className="moduleContent">

                                                    <div className="row">
                                                    
                                                        <Col className="col">
                                                            
                                                            <Form>

                                                                <Form.Group className="mb-3" controlId="formCardName">
                                                                    <Form.Group className="mb-3" controlId="formCardName">
                                                                        <Form.Label>Image pos X <span>({userUploadPFPPosX})</span></Form.Label>
                                                                        &nbsp;<Form.Range type="text" value={userUploadPFPPosX} min={-280} max={280} onChange={evt => updateInputValueForUploadedPFPImageProperties(evt.target.value, 'userUploadPFPPosX')} />
                                                                        <Form.Text className="text-muted">
                                                                        This is the X coordinate for the uploaded image
                                                                        </Form.Text>
                                                                    </Form.Group>
                                                                    <Form.Group className="mb-3" controlId="formCardName">
                                                                        <Form.Label>Image pos Y <span>({userUploadPFPPosY})</span></Form.Label>
                                                                        &nbsp;<Form.Range type="text" value={userUploadPFPPosY} min={-328} max={328} onChange={evt => updateInputValueForUploadedPFPImageProperties(evt.target.value, 'userUploadPFPPosY')} />
                                                                        <Form.Text className="text-muted">
                                                                        This is the Y coordinate for the uploaded image
                                                                        </Form.Text>
                                                                    </Form.Group>
                                                                    <Form.Group className="mb-3" controlId="formCardName">
                                                                        <Form.Label>Image width <span>({userUploadPFPWidth})</span></Form.Label>
                                                                        &nbsp;<Form.Range type="text" value={userUploadPFPWidth} min={0} max={1000} onChange={evt => updateInputValueForUploadedPFPImageProperties(evt.target.value, 'userUploadPFPWidth')} />
                                                                        <Form.Text className="text-muted">
                                                                        This is the width for the uploaded image
                                                                        </Form.Text>
                                                                    </Form.Group>
                                                                    <Form.Group className="mb-3" controlId="formCardName">
                                                                        <Form.Label>Image height <span>({userUploadPFPHeight})</span></Form.Label>
                                                                        &nbsp;<Form.Range type="text" value={userUploadPFPHeight} min={0} max={1000} onChange={evt => updateInputValueForUploadedPFPImageProperties(evt.target.value, 'userUploadPFPHeight')} />
                                                                        <Form.Text className="text-muted">
                                                                        This is the height for the uploaded image
                                                                        </Form.Text>
                                                                    </Form.Group>

                                                                </Form.Group>

                                                            </Form>
                                                            
                                                        </Col>

                                                    </div>

                                                </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                            </>

                                        )}

                                        

                                    </Accordion>
                            </div>   
                        </Collapse>
                    </Card>
                </Container>
            </Col>
        </Row>
    </Container> 

    {/* INSTRUCTIONS PAGE MODAL  */}
    <Modal show={instructionsModalShow} onHide={handleInstructionsModalClose}>
        <Modal.Header>
        <Modal.Title>Instructions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="text-start">
                <p>Welcome to the {props.labelsConfig.instructionsTitle}</p>
                <ul>
                    <li>Tap any {props.labelsConfig.assetName} to bring them to the card!</li>
                    <li>Search for {props.labelsConfig.assetName} by number or by attributes/properties</li>
                    <li>Alternatively, you can upload your own asset</li> 
                    <li>Fill out the card details</li>
                    <li>When finished, click “Download”. Save and print!</li>
                </ul>
            </div>
        </Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={handleInstructionsModalClose}>
            {props.labelsConfig.okButton}
        </Button>
        </Modal.Footer>
    </Modal>
</>

)

}

export default CardGenerator;